import * as LottiePlayer from "@lottiefiles/lottie-player";
import Logo from "../images/logo_light_grey.png";
import PromptSpin from "../images/prompts.lottie";
import NavButton from "./NavButton";
import { getMediaType, getMediaTypeFromUrl } from '../utils/MediaOperations';
import { ReactComponent as GenerateIcon } from "../images/icons/nav-icons/nav-icon-generate.svg";
import { ReactComponent as GenerateIconActive } from "../images/icons/nav-icons/nav-icon-generate-active.svg";
import { ReactComponent as MyCollectionIcon } from "../images/icons/nav-icons/nav-icon-my-collection.svg";
import { ReactComponent as MyCollectionIconActive } from "../images/icons/nav-icons/nav-icon-my-collection-active.svg";
import { ReactComponent as ProfileIcon } from "../images/icons/nav-icons/nav-icon-profile.svg";
import { ReactComponent as ProfileIconActive } from "../images/icons/nav-icons/nav-icon-profile-active.svg";
import { ReactComponent as ExploreIcon } from "../images/icons/nav-icons/nav-icon-explore.svg";
import { ReactComponent as ExploreIconActive } from "../images/icons/nav-icons/nav-icon-explore-active.svg";
import { ReactComponent as SettingsIcon } from "../images/icons/nav-icons/nav-icon-settings.svg";
import { ReactComponent as SettingsIconActive } from "../images/icons/nav-icons/nav-icon-settings-active.svg";
import { ReactComponent as HowToIcon } from "../images/icons/nav-icons/nav-icon-how-to.svg";
import { ReactComponent as HowToIconActive } from "../images/icons/nav-icons/nav-icon-how-to-active.svg";
import { ReactComponent as MarketplaceIcon } from "../images/icons/nav-icons/nav-icon-marketplace.svg";
import { ReactComponent as MarketplaceIconActive } from "../images/icons/nav-icons/nav-icon-marketplace-active.svg";
import { ReactComponent as ChatIcon } from "../images/icons/nav-icons/nav-icon-chat.svg";
import { ReactComponent as ChatIconActive } from "../images/icons/nav-icons/nav-icon-chat-active.svg";
import { ReactComponent as ComfyUIIcon } from "../images/icons/nav-icons/nav-icon-comfyui.svg"
import { ReactComponent as ComfyUIIconActive } from "../images/icons/nav-icons/nav-icon-comfyui-active.svg"
import { ReactComponent as MOMMIcon } from "../images/icons/nav-icons/nav-icon-momm.svg";
import { ReactComponent as MOMMIconActive } from "../images/icons/nav-icons/nav-icon-momm-active.svg"
import { ReactComponent as TemplatesIcon } from "../images/icons/nav-icons/nav-icon-templates.svg";
import { ReactComponent as TemplatesIconActive } from "../images/icons/nav-icons/nav-icon-templates-active.svg"
import { useDriverContextDispatch } from "../context/DriverContext";
import { useAccountContext, useAccountContextDispatch } from "../context/AccountContext";
import { useGenerateDispatch, useGenerateStatus } from "../context/GenerateContext";
import { useEffect, useLayoutEffect, useState, memo, useRef } from "react";
import { useInternetBypass } from '../hooks/useInternetConnectivity';
import { usePromptusAPIState, usePromptusAPIDispatch } from "../context/PromptusAPIContext";
import { db } from "../db";
import { autoLogin, getApiBaseUrl, getCollectionHashes, getCollectionPaginated, getSubscription, getTokens, getUndeliveredImages, getWhmcsData, setReceived, getGenerateOutput, getVersionFromAPI, getUsersMonthlyCredits, cancelJob, cancelCosyJob } from "../api-helper";
import { checkForPendingJobs } from "../services/jobRecoveryService";
import { retrieveDecryptedPassword, migrateExistingPassword } from "../utils/encryption";
import { useCollectionContext, useCollectionContextDispatch } from "../context/CollectionContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import md5 from "blueimp-md5";
import { useMenuState, useMenuDispatch } from "../context/MenuContext";
import MenuButton from "./MenuButton";
import axios from "axios";
import electronBridge, { isElectronEnv } from "../utils/electronBridge";
import eventBus from '../utils/eventBus';
import { ReactComponent as CloseIcon } from "../images/icons/white-close.svg";
import { useUndeliveredImages } from '../hooks';
import { fetchAndCacheModelsFromServer, refreshModelCache, cleanupOfflineServerCache } from '../services/offlineModelService';
import { databaseOperations } from '../services/DatabaseQueue';
import { isFeatureEnabled } from '../config/featureFlags';

function Toggles(props){
    const getColors = () => {
        if (props.status === 'starting') {
            return { ping: 'bg-yellow animate-pulse', solid: 'bg-yellow' };
        }
        if (props.status === 'ready' || props.checked === true) {
            return { ping: 'bg-green-400 animate-ping', solid: 'bg-green-500' };
        }
        return { ping: 'bg-red-400', solid: 'bg-red-500' };
    };
    const colors = getColors();
    return(
        <label className={`relative inline-flex items-center cursor-pointer mr-2 pointer-events-none`} onClick={props.onClick}>
            <span className={`absolute inline-flex h-full w-full rounded-full ${colors.ping} opacity-75`}></span>
            <span className={`relative inline-flex rounded-full h-4 w-4 ${colors.solid}`}></span>
        </label>
    )
}

// Custom hook for media query matching
const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        const media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        const listener = () => setMatches(media.matches);
        media.addListener(listener);
        return () => media.removeListener(listener);
    }, [matches, query]);

    return matches;
};

function NavigationMenu() {
    const generateStatus = useGenerateStatus();
    const generateStatusRef = useRef(generateStatus); // Ref to access current generateStatus in interval
    const driverContextDispatch = useDriverContextDispatch();
    const promptusAPIContext = usePromptusAPIState();
    const promptusAPIDispatch = usePromptusAPIDispatch();
    const accountContext = useAccountContext();
    const accountContextDispatch = useAccountContextDispatch();
    const collectionContext = useCollectionContext();
    const collectionContextDispatch = useCollectionContextDispatch();
    const generateStatusDispatch = useGenerateDispatch();
    const apiState = usePromptusAPIState();
    const { checkingUndeliveredImages: hookCheckingUndeliveredImages } = useUndeliveredImages();
    const { shouldBypass } = useInternetBypass();
    const [serverCPU, setServerCPU] = useState(false);
    const [serverGPU, setServerGPU] = useState(false);
    const [serverCosy, setServerCosy] = useState(false);
    const [serverCloud, setServerCloud] = useState(true);
    const [animations, setAnimations] = useState(false);
    const [previewCosyUI, setPreviewCosyUI] = useState(false);
    const [loading, setLoadingImages] = useState(false);
    const [update, setUpdate] = useState(false);
    const [imageList, setImageList] = useState([]);
    const [undeliveredStatus, setUndeliveredStatus] = useState("");
    const [fetchingUndelivered, setFetchingUndelivered] = useState(false);
    const [refreshingApp, setRefreshingApp] = useState(false);
    const [pendingWorkload, setPendingWorkload] = useState(false);
    const [pendWorkDetails, setPendWorkDetails] = useState({});
    const [pendWorkProgress, setPendWorkProgress] = useState(0)
    // Timer state removed - handled by job recovery service
    const [comfyVisibility, setComfyVisibility] = useState(true)


    const [autoLoggedIn, setAutoLoggedIn] = useState(false);
    const [account, setAccount] = useState({});
    const [accountNo, setAccountNo] = useState("");
    const [loggedIn, setLoggedIn] = useState(false);

    const [hostingCreated, setHostingCreated] = useState('');
    const [hostingDomain, setHostingDomain] = useState('');
    const [hostingStatus, setHostingStatus] = useState('');
    const [hostingSetupInvoice, setHostingSetupInvoice] = useState('');
    const [hostingSetupInvoiceStatus, setHostingSetupInvoiceStatus] = useState('');
    const [hostingSetupInvoiceAmount, setHostingSetupInvoiceAmount] = useState('');
    const [hostingOrderNumber, setHostingOrderNumber] = useState('');
    const [showHostingDetails, setShowHostingDetails] = useState(false);
    const navigate = useNavigate();
    const autoLoginCalled = useRef(false);
    const [authParams, setAuthParams] = useState(null);

    const pollingRef = useRef(null);
    const lowCreditWarningShown = useRef(false);
    const ipcRenderer = electronBridge.ipcRenderer;

    const menuState = useMenuState();
    const menuDispatch = useMenuDispatch();

    const [activeGPU, setActiveGPU] = useState(null);
    const [activeCPU, setActiveCPU] = useState(null);
    const [activeComfyUI, setActiveComfyUI] = useState(null);
    const [activeCosy, setActiveCosy] = useState(null);
    const [activeHorde, setActiveHorde] = useState(null);
    const [activeCWorker, setActiveCWorker] = useState(null);

    // Store detected server URLs for future auto-detection use
    const [detectedServers, setDetectedServers] = useState({});
    const [autoConfiguredServers, setAutoConfiguredServers] = useState(new Set());
    // Ref to track previous detected servers for comparison (avoids closure issues with setState)
    const previousDetectedServersRef = useRef({});

    const [localDirectory, setLocalDirectory] = useState("");
    const [showOptimizationPopup, setShowOptimizationPopup] = useState(false);
    const [optimizationProgress, setOptimizationProgress] = useState({ current: 0, total: 0 });

    const [showNavMenu, setShowNavMenu] = useState(false)

    // Mobile detection using custom max-middle breakpoint (865px)
    const isMobile = useMediaQuery('(max-width: 865px)');

    // Handler to close mobile menu after navigation
    const handleMobileNavigation = () => {
        if (isMobile) {
            setShowNavMenu(false);
        }
    };

    // Update notification state management
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [updateDismissed, setUpdateDismissed] = useState(false);
    const [latestVersion, setLatestVersion] = useState('');
    const [currentVersion] = useState(process.env.REACT_APP_VERSION);

    // Monthly credits data state
    const [monthlyCreditsData, setMonthlyCreditsData] = useState(null);
    const [creditsDataLoading, setCreditsDataLoading] = useState(false);




    useEffect(() => {
        const handler = () => setShowNavMenu(true); // or whatever args you want
        eventBus.on('show_nav_menu', handler);
        return () => eventBus.off('show_nav_menu', handler);
      }, []);

    // Check for previously dismissed updates on component mount
    useEffect(() => {
        const dismissedVersion = localStorage.getItem('dismissedUpdateVersion');
        if (dismissedVersion && dismissedVersion === currentVersion) {
            setUpdateDismissed(true);
        }

        // Clear session dismissal on component mount (new session)
        sessionStorage.removeItem('updateDismissedThisSession');
    }, [currentVersion]);

    // Create a mapping of component strings to their actual components
    const iconMap = {
        'GenerateIcon': GenerateIcon,
        'GenerateIconActive': GenerateIconActive,
        'MyCollectionIcon': MyCollectionIcon,
        'MyCollectionIconActive': MyCollectionIconActive,
        'TemplatesIcon': TemplatesIcon,
        'TemplatesIconActive': TemplatesIconActive,
        'ProfileIcon': ProfileIcon,
        'ProfileIconActive': ProfileIconActive,
        'ExploreIcon': ExploreIcon,
        'ExploreIconActive': ExploreIconActive,
        'SettingsIcon': SettingsIcon,
        'SettingsIconActive': SettingsIconActive,
        'HowToIcon': HowToIcon,
        'HowToIconActive': HowToIconActive,
        'ChatIcon': ChatIcon,
        'ChatIconActive': ChatIconActive,
        'ComfyUIIcon': ComfyUIIcon,
        'ComfyUIIconActive': ComfyUIIconActive,
        'MarketplaceIcon': MarketplaceIcon,
        'MarketplaceIconActive': MarketplaceIconActive,
        'MOMMIcon': MOMMIcon,
        'MOMMIconActive': MOMMIconActive
    };


    const validateMediaUrl = async (url) => {
        if (!url || typeof url !== 'string') {
            return false;
        }

        // Trust Promptus API URLs - skip validation to avoid CORS issues
        if (url.includes('promptus.ai')) {
            return true;
        }

        try {
            const response = await fetch(url, {
                method: 'HEAD',
                headers: {
                    'Accept': 'image/*, video/*, audio/*'
                },
                timeout: 5000
            });
    
            if (!response.ok) {
                return false;
            }
    
            const contentType = response.headers.get('content-type');
            if (!contentType) {
                return false;
            }
    
            const isValidMediaType = contentType.startsWith('image/') ||
                                    contentType.startsWith('video/') ||
                                    contentType.startsWith('audio/');
    
            return isValidMediaType;
        } catch (error) {
            console.warn(`[URL_VALIDATION] Failed to validate URL ${url}:`, error.message);
            return false;
        }
    };

            const findFailedMatches = (failedImages, undeliveredImages) => {
                console.log("Looking for failed matches to deliver");
                
                return undeliveredImages.filter(largeItem => 
                    failedImages.some(smallItem => smallItem.uid === largeItem.jobUid)
                );
            };
            
            const removeFailedMatches = (failedImages, undeliveredImages) => {
                console.log("Removing failed matches from undelivered images");

                return undeliveredImages.filter(largeItem =>
                    !failedImages.some(smallItem => smallItem.uid === largeItem.jobUid)
                );
            };

            const getGenerateOutputWithRetry = async (jobUid, outputUid, maxRetries = 5, delayMs = 1000) => {
                for (let attempt = 1; attempt <= maxRetries; attempt++) {
                    try {
                        console.log(`[UNDELIVERED RECOVERY] Attempting to get generate output (attempt ${attempt}/${maxRetries})`);
                        const result = await getGenerateOutput(jobUid, outputUid);

                        if (result.url && result.url.trim() !== '') {
                            console.log(`[UNDELIVERED RECOVERY] URL found on attempt ${attempt}: ${result.url}`);
                            return result;
                        }

                        if (attempt === maxRetries) {
                            console.log(`[UNDELIVERED RECOVERY] Max retries reached, using base64 fallback`);
                            return result;
                        }

                        console.log(`[UNDELIVERED RECOVERY] No URL found on attempt ${attempt}, waiting ${delayMs}ms before retry...`);
                        await new Promise(resolve => setTimeout(resolve, delayMs));

                    } catch (error) {
                        console.error(`[UNDELIVERED RECOVERY] Error on attempt ${attempt}:`, error);
                        if (attempt === maxRetries) {
                            throw error;
                        }
                        await new Promise(resolve => setTimeout(resolve, delayMs));
                    }
                }
            };

            const checkingUndeliveredImages = async () => {
                console.log("[UNDELIVERED RECOVERY] Starting undelivered images check");
                
                // Atomic check and set to prevent race conditions
                if (fetchingUndelivered) {
                    console.log("[UNDELIVERED RECOVERY] Already processing, skipping");
                    return;
                }
                setFetchingUndelivered(true);

                try {

                console.log("[UNDELIVERED RECOVERY] Acount State:", accountContext);
    
                let fallbackAv = false;
                let fallbackData = null;
                // Validate required dependencies
                if (!accountContext.accountDetails.accountNo) {
                    console.log("[UNDELIVERED RECOVERY] Missing account details from context, attempting accountdata retrieval from local storage");
                    fallbackData = JSON.parse(localStorage.getItem('account'))
                    if (fallbackData !== null) {
                        fallbackAv = true
                    } else {
                        console.error("[UNDELIVERED RECOVERY] Missing account details from local storage as well, aborting");
                        setFetchingUndelivered(false)
                        return; 
                    }
                }

                const userAccountNo = fallbackAv? fallbackData.accountNo : accountContext.accountDetails.accountNo;
    
                console.log("[UNDELIVERED RECOVERY] AccountNo: ", userAccountNo);
                console.log("[UNDELIVERED RECOVERY] API State:", apiState);

                if (apiState.online === true && !shouldBypass) {
                    console.log("[UNDELIVERED RECOVERY] Starting recovery process");
    
                    let moreUndeliveredImages = true;
                    let iterationCount = 0;
                    const maxIterations = 50; // Prevent infinite loops
                    const startTime = Date.now();
                    const maxProcessingTime = 10 * 60 * 1000; // 10 minutes max
    
                    try {
                        while (moreUndeliveredImages && iterationCount < maxIterations) {
                            // Check timeout
                            if (Date.now() - startTime > maxProcessingTime) {
                                console.warn("[UNDELIVERED RECOVERY] Processing timeout reached, stopping");
                                break;
                            }
    
                            // Check cancellation
                            if (generateStatus.cancellingUndeliveredCheck) {
                                console.log("[UNDELIVERED RECOVERY] Cancellation requested, stopping");
                                break;
                            }
    
                            iterationCount++;
                            console.log(`[UNDELIVERED RECOVERY] Iteration ${iterationCount}/${maxIterations}`);
    
                            try {
                                const data = await getUndeliveredImages(userAccountNo);
                                console.log('[UNDELIVERED RECOVERY] DATA: ',data);
                                
                                // Enhanced error handling
                                if (!data) {
                                    console.warn("[UNDELIVERED RECOVERY] No data received from API");
                                    moreUndeliveredImages = false;
                                    return;
                                }
    
                                if (data.error) {
                                    console.error("[UNDELIVERED RECOVERY] API error:", data.message);
                                    moreUndeliveredImages = false;
                                    return;
                                }
    
                                if (!Array.isArray(data)) {
                                    console.error("[UNDELIVERED RECOVERY] Invalid data format, expected array:", typeof data);
                                    moreUndeliveredImages = false;
                                    return;
                                }
    
                                console.log(`[UNDELIVERED RECOVERY] Received ${data.length} undelivered items`);

                                // Filter and validate UIDs - both jobUid and uid must be valid
                                const undeliveredUids = data.filter(item =>
                                    item &&
                                    typeof item === 'object' &&
                                    item.jobUid &&
                                    item.jobUid.trim() !== "" &&
                                    item.uid &&
                                    item.uid.trim() !== ""
                                );

                                const filteredOutCount = data.length - undeliveredUids.length;
                                console.log(`[UNDELIVERED RECOVERY] Filtered to ${undeliveredUids.length} valid items (filtered out ${filteredOutCount} invalid items)`);
    
                                // Stop if no valid items found
                                if (undeliveredUids.length === 0) {
                                    console.log("[UNDELIVERED RECOVERY] No more valid undelivered images, stopping");
                                    moreUndeliveredImages = false;
                                    return;
                                }
            
                                generateStatusDispatch({ type: 'undeliveredImages' });
                                generateStatusDispatch({ type: 'totalUndeliveredImages', totalUndeliveredImages: undeliveredUids.length });
            
                                // Find all images with empty image content (regardless of online status)
                                const undeliveredFailedImages = await db.images
                                    .filter(image => !image.image || image.image === "")
                                    .toArray();
    
                                // More efficient deduplication using Map
                                const uniqueImageMap = new Map();
                                undeliveredFailedImages.forEach(item => {
                                    if (item.uid && !uniqueImageMap.has(item.uid)) {
                                        uniqueImageMap.set(item.uid, item);
                                    }
                                });
                                const uniqueArray = Array.from(uniqueImageMap.values());
    
                                console.log(`[UNDELIVERED RECOVERY] Found ${undeliveredFailedImages.length} failed images, ${uniqueArray.length} unique`);
            
                            const failedMatches = findFailedMatches(uniqueArray, undeliveredUids);
                            console.log("Found undelivered images: ", failedMatches);
            
                            if (failedMatches.length > 0) {
                                for (const undeliveredFailedImage of failedMatches) {
                                    generateStatusDispatch({ type: 'checkingUndeliveredImages' });
                                    console.log(`[UNDELIVERED RECOVERY] Processing undelivered image: ${undeliveredFailedImage.uid}`);
    
                                    try {
                                        // Modern approach: Find specific placeholders for this job
                                        const placeholders = await db.images
                                            .where('uid').equals(undeliveredFailedImage.jobUid)
                                            .and(item => !item.image || item.image === '')
                                            .and(item => item.dataType !== "placeholder")
                                            .toArray();
    
                                        if (placeholders.length > 0) {
                                            console.log(`[UNDELIVERED RECOVERY] Found ${placeholders.length} placeholders for job ${undeliveredFailedImage.jobUid}`);
    
                                            // Use the first available placeholder (or implement better selection logic)
                                            const placeholder = placeholders[0];
                                            console.log(`[UNDELIVERED RECOVERY] Using placeholder ${placeholder.id} for output ${undeliveredFailedImage.uid}`);
    
                                            // Check for hash conflicts before proceeding
                                            const hashcheck = await db.images.where('hash').equals(undeliveredFailedImage.uid).first();
                                            if (hashcheck && hashcheck.id !== placeholder.id) {
                                                console.error(`[UNDELIVERED RECOVERY] Hash conflict: ${undeliveredFailedImage.uid} already used by record ${hashcheck.id}`);
                                                continue;
                                            }
    
                                            generateStatusDispatch({ type: 'retrievingUndeliveredImages' });
                                            const image = await getGenerateOutputWithRetry(undeliveredFailedImage.jobUid, undeliveredFailedImage.uid);
                                            console.log('[UNDELIVERED RECOVERY] Media retrieved from API: ', image);
                                            let imageData = null;
                                            const isUrlValid = await validateMediaUrl(image.url);
                                            if (isUrlValid) {
                                                imageData = image.url;
                                                console.log('[FETCH JOB] Using validated URL for image data');
                                            } else {
                                                imageData = image.image || image.url;
                                                console.log('[FETCH JOB] URL validation failed, using base64 fallback or original URL');
                                            }
                                            
                                            let dataType = image.url ? getMediaTypeFromUrl(image.url) : 'Unknown';
                                            if (dataType === 'Unknown' && image.image) {
                                                dataType = await getMediaType(image.image);
                                            }

                                            // Check if this exact image already exists
                                            const imageCheck = await db.images.where('image').equals(image.image).first();
                                            if (imageCheck && imageCheck.id !== placeholder.id) {
                                                console.log(`[UNDELIVERED RECOVERY] Image already exists in record ${imageCheck.id}, skipping`);
                                                continue;
                                            }
    
                                            // Update the specific placeholder (not create new record)
                                            const updateData = {
                                                image: imageData,
                                                seed: image.seed,
                                                model: image.model ?? '',
                                                hash: undeliveredFailedImage.uid,
                                                online: true,
                                                tag: "",
                                                prompt: image.prompt ?? '',
                                                receivedtimestamp: Date.now(),
                                                requestedtimestamp: Date.now(),
                                                dataType: dataType.toLowerCase()
                                            };

                                            if (isFeatureEnabled('USE_DATABASE_QUEUE')) {
                                                await databaseOperations.updateImage(placeholder.id, updateData);
                                            } else {
                                                await db.images.update(placeholder.id, updateData);
                                            }
    
                                            generateStatusDispatch({ type: 'totalRetrievedImages' });
                                            console.log(`[UNDELIVERED RECOVERY] Successfully updated placeholder ${placeholder.id} with image`);

                                            // Refresh gallery to show recovered image
                                            eventBus.emit('refreshImages');
    
                                        } else {
                                            console.warn(`[UNDELIVERED RECOVERY] No placeholders found for job ${undeliveredFailedImage.jobUid}`);
    
                                            // Fallback: Check if image already exists before creating new record
                                            const existingCheck = await db.images.where('hash').equals(undeliveredFailedImage.uid).first();
                                            if (!existingCheck) {
                                                generateStatusDispatch({ type: 'retrievingUndeliveredImages' });
                                                const image = await getGenerateOutputWithRetry(undeliveredFailedImage.jobUid, undeliveredFailedImage.uid);
                                                console.log('[UNDELIVERED RECOVERY] Media retrieved from API: ', image);
                                                let dataType = image.url ? getMediaTypeFromUrl(image.url) : 'Unknown';
                                                if (dataType === 'Unknown' && image.image) {
                                                    dataType = await getMediaType(image.image);
                                                }
                                                let imageData = null;
                                                const isUrlValid = await validateMediaUrl(image.url);
                                                if (isUrlValid) {
                                                    imageData = image.url;
                                                    console.log('[FETCH JOB] Using validated URL for image data');
                                                } else {
                                                    imageData = image.image || image.url;
                                                    console.log('[FETCH JOB] URL validation failed, using base64 fallback or original URL');
                                                }
    
                                                // Final duplicate check by image content
                                                const imageContentCheck = await db.images.where('image').equals(image.image).first();
                                                if (!imageContentCheck) {
                                                    const newImageData = {
                                                        image: imageData,
                                                        seed: image.seed,
                                                        uid: undeliveredFailedImage.jobUid,
                                                        model: image.model ?? '',
                                                        inCollection: false,
                                                        hash: undeliveredFailedImage.uid,
                                                        online: true,
                                                        tag: "",
                                                        prompt: image.prompt ?? '',
                                                        receivedtimestamp: Date.now(),
                                                        requestedtimestamp: Date.now(),
                                                        dataType: dataType.toLowerCase()
                                                    };

                                                    if (isFeatureEnabled('USE_DATABASE_QUEUE')) {
                                                        await databaseOperations.addImage(newImageData);
                                                    } else {
                                                        await db.images.add(newImageData);
                                                    }
                                                    generateStatusDispatch({ type: 'totalRetrievedImages' });
                                                    console.log(`[UNDELIVERED RECOVERY] Created new record for undelivered image ${undeliveredFailedImage.uid}`);

                                                    // Refresh gallery to show recovered image
                                                    eventBus.emit('refreshImages');
                                                } else {
                                                    console.log(`[UNDELIVERED RECOVERY] Image content already exists, skipping`);
                                                }
                                            } else {
                                                console.log(`[UNDELIVERED RECOVERY] Image already exists with hash: ${undeliveredFailedImage.uid}`);
                                            }
                                        }
    
                                        setReceived(undeliveredFailedImage.jobUid, undeliveredFailedImage.uid);
    
                                    } catch (error) {
                                        console.error(`[UNDELIVERED RECOVERY] Error processing undelivered image ${undeliveredFailedImage.uid}:`, error);
                                        // Continue with next image instead of failing completely
                                    }
                                }

                                // Refresh gallery after processing failed matches batch
                                if (failedMatches.length > 0) {
                                    console.log(`[UNDELIVERED RECOVERY] Completed processing ${failedMatches.length} failed matches, refreshing gallery`);
                                    eventBus.emit('refreshImages');
                                }
                            }

                            const remainingImages = removeFailedMatches(uniqueArray, undeliveredUids);
                            console.log("Remaining Images: ", remainingImages);
            
                            if (remainingImages.length > 0) {
                                console.log("There are undelivered images that are not failed images");
                                if (remainingImages.length > 50) {
                                    Swal.fire({
                                        color: "#190A4E",
                                        title: `You have ${remainingImages.length} undelivered images. This is a large amount of image and it might take some time so please be patient.`,
                                        icon: "info",
                                        showConfirmButton: false,
                                        showCancelButton: false,
                                        timer: 2000
                                    });
                                }
            
                                // Process remaining images sequentially to avoid race conditions and better error handling
                                for (const undeliveredImage of remainingImages) {
                                    generateStatusDispatch({ type: 'checkingUndeliveredImages' });
                                    console.log(`[UNDELIVERED RECOVERY] Processing remaining image: ${undeliveredImage.uid}`);
    
                                    try {
                                        // Validate uid and jobUid before database operations
                                        if (!undeliveredImage.uid || typeof undeliveredImage.uid !== 'string' || undeliveredImage.uid.trim() === '') {
                                            console.warn(`[UNDELIVERED RECOVERY] Skipping item with invalid uid:`, undeliveredImage);
                                            continue;
                                        }
                                        if (!undeliveredImage.jobUid || typeof undeliveredImage.jobUid !== 'string' || undeliveredImage.jobUid.trim() === '') {
                                            console.warn(`[UNDELIVERED RECOVERY] Skipping item with invalid jobUid:`, undeliveredImage);
                                            continue;
                                        }

                                        // Check if this hash already exists first
                                        const hashcheck = await db.images.where('hash').equals(undeliveredImage.uid).first();
                                        if (hashcheck) {
                                            console.log(`[UNDELIVERED RECOVERY] Image already exists with hash: ${undeliveredImage.uid}`);
                                            setReceived(undeliveredImage.jobUid, undeliveredImage.uid);
                                            continue;
                                        }
    
                                        generateStatusDispatch({ type: 'retrievingUndeliveredImages' });
                                        const image = await getGenerateOutputWithRetry(undeliveredImage.jobUid, undeliveredImage.uid);
                                        console.log('[UNDELIVERED RECOVERY] Media retrieved from API: ', image);
                                        let dataType = image.url ? getMediaTypeFromUrl(image.url) : 'Unknown';
                                        if (dataType === 'Unknown' && image.image) {
                                            dataType = await getMediaType(image.image);
                                        }
                                        let imageData = null;
                                        const isUrlValid = await validateMediaUrl(image.url);
                                        if (isUrlValid) {
                                            imageData = image.url;
                                            console.log('[FETCH JOB] Using validated URL for image data');
                                        } else {
                                            imageData = image.image || image.url;
                                            console.log('[FETCH JOB] URL validation failed, using base64 fallback or original URL');
                                        }
    
                                        // Double-check for image content duplicates
                                        const imageCheck = await db.images.where('image').equals(image.image).first();
                                        if (imageCheck) {
                                            console.log(`[UNDELIVERED RECOVERY] Image content already exists in record ${imageCheck.id}`);
                                            setReceived(undeliveredImage.jobUid, undeliveredImage.uid);
                                            continue;
                                        }
    
                                        // Use add() instead of put() to prevent overwriting existing records
                                        const remainingImageData = {
                                            image: imageData,
                                            seed: image.seed,
                                            uid: undeliveredImage.jobUid,
                                            model: image.model ?? '',
                                            inCollection: false,
                                            hash: undeliveredImage.uid,
                                            online: apiState.online,
                                            tag: "",
                                            prompt: image.prompt ?? '',
                                            receivedtimestamp: Date.now(),
                                            requestedtimestamp: Date.now(),
                                            dataType: dataType.toLowerCase()
                                        };

                                        if (isFeatureEnabled('USE_DATABASE_QUEUE')) {
                                            await databaseOperations.addImage(remainingImageData);
                                        } else {
                                            await db.images.add(remainingImageData);
                                        }

                                        generateStatusDispatch({ type: 'totalRetrievedImages' });
                                        console.log(`[UNDELIVERED RECOVERY] Successfully added undelivered image ${undeliveredImage.uid}`);
                                        setReceived(undeliveredImage.jobUid, undeliveredImage.uid);

                                        // Refresh gallery to show recovered image
                                        eventBus.emit('refreshImages');
    
                                    } catch (error) {
                                        console.error(`[UNDELIVERED RECOVERY] Error processing remaining image ${undeliveredImage?.uid || 'unknown'}:`, error);
                                        console.error(`[UNDELIVERED RECOVERY] Problematic item:`, undeliveredImage);

                                        // Only call setReceived if we have valid UIDs to avoid additional errors
                                        if (undeliveredImage?.jobUid && undeliveredImage?.uid) {
                                            setReceived(undeliveredImage.jobUid, undeliveredImage.uid);
                                        } else {
                                            console.warn(`[UNDELIVERED RECOVERY] Cannot mark as received - invalid UIDs in item:`, undeliveredImage);
                                        }
                                    }
                                }

                                // Refresh gallery after processing remaining images batch
                                if (remainingImages.length > 0) {
                                    console.log(`[UNDELIVERED RECOVERY] Completed processing ${remainingImages.length} remaining images, refreshing gallery`);
                                    eventBus.emit('refreshImages');
                                }
                            } // Close the data processing block
    
                            } catch (apiError) {
                                console.error(`[UNDELIVERED RECOVERY] API call failed (iteration ${iterationCount}):`, apiError);
    
                                // Implement exponential backoff for retries
                                const backoffDelay = Math.min(1000 * Math.pow(2, iterationCount - 1), 30000); // Cap at 30s
                                console.log(`[UNDELIVERED RECOVERY] Backing off for ${backoffDelay}ms before retry`);
    
                                await new Promise(resolve => setTimeout(resolve, backoffDelay));
    
                                // Stop after too many consecutive failures
                                if (iterationCount > 5) {
                                    console.error(`[UNDELIVERED RECOVERY] Too many API failures, stopping recovery`);
                                    moreUndeliveredImages = false;
                                }
                            }
    
                            console.log(`[UNDELIVERED RECOVERY] Completed iteration ${iterationCount}`);
                        }
    
                        console.log(`[UNDELIVERED RECOVERY] Recovery process completed after ${iterationCount} iterations`);
    
                    } catch (fatalError) {
                        console.error(`[UNDELIVERED RECOVERY] Fatal error in recovery process:`, fatalError);
                        generateStatusDispatch({ type: 'done' });
                        setFetchingUndelivered(false);
                    } finally {
                        // Always reset the cancellation flag
                        if (generateStatus.cancellingUndeliveredCheck) {
                            generateStatusDispatch({ type: 'resetcancellingUndeliveredCheck' });
                        }
                    }
                } else {
                    console.log(`[UNDELIVERED RECOVERY] Skipping recovery - Offline mode detected`);
                }
    
                console.log(`[UNDELIVERED RECOVERY] Process completed`);
                generateStatusDispatch({ type: 'done' });

                // Final gallery refresh after completion
                eventBus.emit('refreshImages');

                // Reset fetching state to ensure UI is properly cleaned up
                setFetchingUndelivered(false);

                } catch (error) {
                    console.error(`[UNDELIVERED RECOVERY] Top-level error:`, error);
                    generateStatusDispatch({ type: 'done' });
                } finally {
                    // Ensure flag is always reset
                    setFetchingUndelivered(false);
                }
            };

    const refreshApp = async() => {
        console.log('[REFRESH] Starting refresh app with undelivered images check');
        setRefreshingApp(true);

        try {
            // Run the undelivered images check before reloading
            await hookCheckingUndeliveredImages();
            console.log('[REFRESH] Undelivered images check completed, reloading page');
        } catch (error) {
            console.error(`[REFRESH] Error during undelivered images check:`, error);
        } finally {
            // Always reload the page regardless of check success/failure
            document.location.reload();
        }
    }

    // Fetch monthly credits allowance data
    const fetchMonthlyCredits = async () => {
        if (!accountContext.loggedIn || !accountContext.accountDetails?.accountNo || creditsDataLoading) {
            return;
        }

        if (shouldBypass) {
            console.log('[MONTHLY CREDITS] Offline mode - skipping monthly credits fetch');
            return;
        }

        setCreditsDataLoading(true);
        try {
            console.log('[MONTHLY CREDITS] Fetching monthly credits for account:', accountContext.accountDetails.accountNo);
            const data = await getUsersMonthlyCredits(accountContext.accountDetails.accountNo);
            console.log('[MONTHLY CREDITS] Received data:', data);
            setMonthlyCreditsData(data);
        } catch (error) {
            console.error('[MONTHLY CREDITS] Error fetching monthly credits:', error);
            setMonthlyCreditsData(null);
        } finally {
            setCreditsDataLoading(false);
        }
    };

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////// INITIALIZATON AND EDITING OF DB VALUES //////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        ////////////////////////////////////////////////////// ELECTRON ONLY CODE /////////////////////////////////////////////////
        if (electronBridge.isElectron) {
            const changeImageData = async () => {
                await db.open();

                if (db.isOpen()) {
                  console.log("Database is open");
                }

                const idQueue = [];

                // Stream-safe, no full record storage - include both base64 and URLs (exclude file paths)
                await db.images.orderBy('id').each(image => {
                  const isWindowsPath = image.image && /^[a-zA-Z]:[\\/]/.test(image.image);
                  const isUnixPath = image.image && image.image.startsWith('/');
                  if (image.image && !isWindowsPath && !isUnixPath) {
                    idQueue.push(image.id);
                  }
                });

                if (idQueue.length > 0) {
                    setShowOptimizationPopup(true);
                    setOptimizationProgress({ current: 0, total: idQueue.length });
                }

                let i = 0;
                for (const id of idQueue) {
                  try {
                    const image = await db.images.get(id);
                    const isWindowsPath = /^[a-zA-Z]:[\\/]/.test(image.image);
                    if (!image || !image.image || isWindowsPath || image.image == "") continue;

                    console.log("PERFORMANCE: Updating image ID:", image.id);

                    let imageContent = image.image;
                    if (image.image.startsWith('http://') || image.image.startsWith('https://')) {
                        try {
                            console.log(`PERFORMANCE: Downloading URL for image ${id}: ${image.image}`);
                            const response = await fetch(image.image);
                            const blob = await response.blob();
                            const reader = new FileReader();
                            imageContent = await new Promise((resolve, reject) => {
                                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                                reader.onerror = reject;
                                reader.readAsDataURL(blob);
                            });
                        } catch (err) {
                            console.error(`PERFORMANCE: Failed to download URL for image ${id}:`, err);
                            continue;
                        }
                    }

                    const dataType = await getMediaType(imageContent);
                    const savedFilePath = await ipcRenderer.invoke("test_upload", imageContent, localDirectory, null, dataType);

                    await db.images.update(image.id, {
                      image: savedFilePath,
                      dataType: dataType.toLowerCase()
                    });
                    i++
                    setOptimizationProgress({ current: i, total: idQueue.length });
                    console.log(`'PERFORMANCE: Updated imageHash: ${image.hash}, file path: ${savedFilePath}`);
                    } catch (err) {
                        console.error(`Error updating image ID ${id}:`, err);
                    } finally {
                        console.log('PERFORMANCE: Finished updating all image records.');
                    }
                }
                if (i > 0) {
                    setShowOptimizationPopup(false); // Hide popup before reload
                    document.location.reload();
                }

              };

            const checkImageExists = async () => {
                console.log('STARTING SECURIRY CHECK ON MISSING IMAGES');
                
                await db.open();
              
                if (db.isOpen()) {
                  console.log("Database is open");
                }
              
                const idQueue = [];
              
                // Stream-safe, no full record storage
                await db.images.orderBy('id').each(image => {
                    const isWindowsPath = /^[a-zA-Z]:[\\/]/.test(image.image);
                    console.log("IS WINDOWS PATH: ", isWindowsPath, "IMAGE: ", image.image);
                    if (image?.image && isWindowsPath) {
                        idQueue.push(image.id);
                    }
                });

                // if (idQueue.length > 0) {
                //     setShowOptimizationPopup(true);
                //     setOptimizationProgress({ current: 0, total: idQueue.length });
                // }
              
                let i = 0;
                for (const id of idQueue) {
                  try {
                    const image = await db.images.get(id);
                    const isWindowsPath = /^[a-zA-Z]:[\\/]/.test(image.image);
                    console.log("IS WINDOWS PATH: ", isWindowsPath, "IMAGE: ", image.image);
                    // if (!image || !image.image || image.image.startsWith("http") || image.image.includes(':\\') || image.image.includes(':/') || image.image == "") continue;
                    if (image?.image && isWindowsPath) {
                        console.log("SECURITY CHECK: Checking if image exists:", image.image);
                        // const dataType = await getMediaType(image.image);
                        const fileExists = await ipcRenderer.invoke("checkImageExists", image.image);
                        if (!fileExists) {
                            db.images
                            .where("id")
                            .equals(image.id)
                            .delete()
                            i++
                            console.log(`'SECURITY CHECK: Removed imageHash: ${image.hash} as file path: ${image.image} does not exist`);
                        }
                        // setOptimizationProgress({ current: i, total: idQueue.length });
                    }
                    } catch (err) {
                        console.error(`Error checking image ID ${id}:`, err);
                    } finally {
                        console.log('SECURITY CHECK: Finished removing all not existent image records.');
                    }
                }
                if (i > 0) {
                    // setShowOptimizationPopup(false); // Hide popup before reload
                    eventBus.emit('refreshImages');
                }
            }  
    
            changeImageData();
            checkImageExists();
        }
         //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        const updatePrompts = async () => {
            await db.open();

            if (db.isOpen()) {
                console.log("Database is open");
                
            }
            db.transaction('rw', db.images, db.collection, async () => {        
                console.log("Updating prompts in the local DB");      
                await db.images.orderBy('id').each(async image => {                    
                    if (!image.prompt || image.prompt == '') {
                        console.log("Prompt is empty, updating prompt for image: ", image.id);
                        const promptHistory = async () => await db.collection.where('uid').equals(image.uid).first();            
                        promptHistory().then(async (data) => {                
                            if (data && data.prompt && data.prompt.prompt && data.prompt.prompt.prompt) {
                                console.log("Updating prompt for image: ", image.id, " with prompt: ", data.prompt.prompt.prompt);
                                await db.images.update(image.id, {prompt: data.prompt.prompt.prompt})
                            } else if (data) {
                                console.warn(`Skipping prompt update for image ${image.id} - unexpected prompt structure:`, data);
                            }
                        }).catch(err => {
                            console.error(`Error fetching prompt history for image ${image.id}:`, err);
                        });
                    }
                    
                    const modelForCheck = (image.model || '').toLowerCase()
                    if (image.dataType && image.dataType == "image" && modelForCheck.includes('veo')) {
                        await db.images.update(image.id, {dataType: 'video'})
                    }   
                });
              }).then(() => {
                console.log('Prompts have been successfully added.');
              }).catch(err => {
                console.error('Failed to update timestamps:', err);
              });
        }

        const updateTimestamps = async() => {
            await db.open();
            if (db.isOpen()) {
                console.log("Database is open");
            }
            // Assume a time gap between records, e.g., 1 second
            const timeGap = 1000; // 1 second in milliseconds
            const totalNumberOfRecords = await db.images.count();
            
            // Start with an initial timestamp, such as the current time minus the total time span
            const initialTimestamp = Date.now() - (timeGap * (totalNumberOfRecords - 1));

            db.transaction('rw', db.images, async () => {
            let currentTimestamp = initialTimestamp;

            await db.images.orderBy('id').each(async image => {
                if (!image.receivedtimestamp || !image.requestedtimestamp) {
                    console.log("Timestamps are empty, updating timestamps for image: ", image.id);                    
                    console.log("Updating timestamps for image: ", image.id, " with timestamp: ", currentTimestamp);
                    await db.images.update(image.id, { receivedtimestamp: currentTimestamp, requestedtimestamp: currentTimestamp });
                    currentTimestamp += timeGap;
                }
            });
            }).then(() => {
                console.log('Timestamps have been successfully added.');
            }).catch(err => {
                console.error('Failed to update timestamps:', err);
            });
        }

        const updateSHtoAI = async() => {
            await db.open();
            if (db.isOpen()) {
                console.log("Database is open");
            }

            db.transaction('rw', db.images, async () => {
            await db.images.orderBy('id').each(async image => {
                if (image.model && image.model.includes('SH')) {
                    let newModel = image.model.replace('SH', 'AI-Horde');
                    console.log("Model includes SH, updating model for image: ", image.id, image.model, newModel);
                    await db.images.update(image.id, { model: newModel });
                }
            });
            }).then(() => {
                console.log('Conversion from SH to AI Horde have been successfully completed.');
            }).catch(err => {
                console.error('Failed to update SH:', err);
            });
        }

        const updateDataTypes = async() => {
            await db.open();
            if (db.isOpen()) {
                console.log("Database is open");
            }

            db.transaction('rw', db.images, async () => {
            await db.images.orderBy('id').each(async image => {
                if (!image.dataType || image.dataType === '') {
                    console.log("DataType is empty, updating dataType for image: ", image.id);
                    await db.images.update(image.id, { dataType: "image" });
                }
            });
            }).then(() => {
                console.log('P- Conversion from SH to AI Horde have been successfully completed.');
            }).catch(err => {
                console.error('Failed to update SH:', err);
            });

            db.transaction('rw', db.collectedImages, async () => {
            await db.collectedImages.orderBy('id').each(async image => {
                if (!image.dataType || image.dataType === '') {
                    console.log("DataType is empty, updating dataType for image: ", image.id);
                    await db.collectedImages.update(image.id, { dataType: "image" });
                }
            });
            }).then(() => {
                console.log('C- Conversion from SH to AI Horde have been successfully completed.');
            }).catch(err => {
                console.error('Failed to update SH:', err);
            });
        }

        const updateImageHashes = async() => {
            await db.open();
            if (db.isOpen()) {
                console.log("Database is open");
            }

            db.transaction('rw', db.images, async () => {
            await db.images.orderBy('id').each(async image => {
                if (image.hash && typeof image.hash === 'object' && !Array.isArray(image.hash)) {
                    console.log("Invalid hash found for hash: ", image.id);
                    const md5_hash = md5(image.image)
                    await db.images.update(image.id, { hash: md5_hash });
                }
            });
            }).then(() => {
                console.log('P- Update of invalid hashes successful.');
            }).catch(err => {
                console.error('Failed to update invalid hashes: ', err);
            });

            db.transaction('rw', db.collectedImages, async () => {
            await db.collectedImages.orderBy('id').each(async image => {
                if (image.hash && typeof image.hash === 'object' && !Array.isArray(image.hash)) {
                    console.log("Invalid hash found for hash: ", image.id);
                    const md5_hash = md5(image.image)
                    await db.collectedImages.update(image.id, { hash: md5_hash });
                }
            });
            }).then(() => {
                console.log('C- Update of invalid hashes successful.');
            }).catch(err => {
                console.error('Failed to update invalid hashes: ', err);
            });
        }

        //////////////////////// TEST ////////////////////////////
        const updateCosyflowsVarData = async () => {
            await db.open();
            if (db.isOpen()) {
                console.log("Database is open");
            }
        
            db.transaction('rw', db.cosyflows, async () => {
                await db.cosyflows.orderBy('id').each(async (image) => {
                    // Check and remove params.count if it exists
                    if (image?.data?.variables?.["prompt"]) {
                        delete image.data.variables["prompt"];
        
                        // Save back the updated record
                        await db.cosyflows.put(image);
                        console.log(`Removed prompt from id: ${image.id}`);
                    }
                });
            }).then(() => {
                console.log('✅ Update of cosyflows data successful.');
            }).catch(err => {
                console.error('❌ Failed to update cosyflows data: ', err);
            });
        };
        // updateCosyflowsVarData();
        //////////////////////////////////////////////////////////////        
        updateSHtoAI();
        updatePrompts();
        updateTimestamps();
        updateDataTypes();
        updateImageHashes();
    },[]);

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        // Only run if user is logged in and has account details
        if (accountContext.loggedIn && accountContext.accountDetails?.accountNo) {
            console.log("[UNDELIVERED RECOVERY] NavigationMenu useEffect triggered - account change detected");
            (async()=>{
                await checkingUndeliveredImages();
            })()
        } else {
            console.log("[UNDELIVERED RECOVERY] NavigationMenu useEffect skipped - user not logged in or no account details");
        }
    },[accountContext.accountDetails?.accountNo, accountContext.loggedIn])

    let populating = false;
    const populateCollection = async (accountNo) => {
        if (populating) {
            console.log("Collection Busy Populating");
            return;
        }
    
        populating = true;
        console.log("Populating collection with images from the server using paginated API");
        
        try {
            // Fetch collection in batches using paginated endpoint
            const batchSize = 100; // Fetch 100 images at a time
            let pageNo = 1;
            let hasMore = true;
            let totalProcessed = 0;
            
            while (hasMore) {
                const response = await getCollectionPaginated(accountNo, batchSize, pageNo);
                
                if (response && response.data && response.data.length > 0) {
                    // Process batch of images
                    for (const image of response.data) {
                        const hashcheck = await db.collectedImages.where('hash').equals(image.hash).first();
                        if (!hashcheck) {
                            await db.collectedImages.put({
                                uid: image.uid,
                                imageID: totalProcessed + 1,
                                image: image.image,
                                seed: image.seed,
                                model: image.model,
                                hash: image.hash,
                                online: image.online || true,
                                tag: image.tag || "",
                                prompt: image.prompt,
                                public: image.public || false,
                                dataType: image.dataType || "image"
                            });
                            console.log("Loaded image from server batch: ", image.hash);
                        }
                        totalProcessed++;
                    }
                    
                    // Check if there are more pages
                    hasMore = response.data.length === batchSize;
                    pageNo++;
                } else {
                    hasMore = false;
                }
            }
            
            collectionContextDispatch({type: 'totalImages', payload: totalProcessed});
            console.log(`Finished loading ${totalProcessed} images from the server`);
            
        } catch (error) {
            console.error("An error occurred while loading images: ", error);
        } finally {
            console.log("THE FINALLY SECTION");
            sessionStorage.setItem('finishedCollectionLoad', 'true');
            collectionContextDispatch({type: 'finishedLoading'});
            populating = false;
        }
            // const imagePromises = hashArray.map((hash, index) => {
            //     return getCollectionImage(accountNo, hash.hash)
            //         .then(image => {
            //             // Create an object that includes both the image and its original index
            //             return { image, index };
            //         });
            // });

            // // Wait for all promises to resolve
            // Promise.all(imagePromises).then(images => {
            //     images.forEach(({ image, index }) => {
            //         // Now you can use the index if needed to maintain original order
            //         const hashcheck = db.collectedImages.where('hash').equals(image.hash).first();
            //         if (!hashcheck) {
            //             db.collectedImages.put({uid: image.uid, imageID: index + 1, image: image.image, seed: image.seed, model: image.model, hash: image.hash, online: image.online, tag: image.tag, prompt: image.prompt, public: image.public});
            //             console.log("Loaded image from the server: ", image.imageID, image.hash);
            //         }
            //     });
            //     console.log("Finished loading images from the server");
            //     // collectionContextDispatch({type: 'finishedLoading'});
            // }).catch(error => {
            //     console.error("An error occurred while loading images: ", error);
            // }).finally(() => {
            //     sessionStorage.setItem('finishedCollectionLoad', 'true');
            //     collectionContextDispatch({type: 'finishedLoading'});
            //     populating = false
            //     //setLogloading(false);
            // });

    }


    useEffect(() => {
        console.log('[NavigationMenu] 🚀 NavigationMenu useEffect starting...');
        ipcRenderer.send("pwa-log", "React - Navigation UseEffect Start")
        async function fetchLocalDir() {
            await db.settings.toArray((settings) => {
                console.log("Settings: ", settings);
                settings.forEach(setting => {
                    if (setting.key === "local_directory") {
                        return setting.value ;
                    }
                })
            })
        }
        setLocalDirectory(fetchLocalDir);

        console.log('[NavigationMenu] Checking localStorage for account...');
        const storedAccount = localStorage.getItem('account');
        console.log('[NavigationMenu] Stored account check:', {
            hasAccount: !!storedAccount,
            accountLength: storedAccount ? storedAccount.length : 0
        });

        if (storedAccount) {
            console.log('[NavigationMenu] ✅ Found stored account - proceeding with login');
            let accountDetails;
            try {
                accountDetails = JSON.parse(storedAccount);
                console.log('[NavigationMenu] Parsed account details:', {
                    accountNo: accountDetails.accountNo,
                    alias: accountDetails.alias,
                    hasTokens: !!accountDetails.tokens
                });
            } catch (error) {
                console.error("[NavigationMenu] Error grabbing account from local storage: ", error);
            }

            // Handle password decryption asynchronously
            const initializeUserSession = async () => {
                let passSecret = null;
                
                try {
                    // First try to migrate any existing plain text password
                    await migrateExistingPassword();
                    
                    // Then retrieve the (now encrypted) password
                    passSecret = await retrieveDecryptedPassword();
                } catch (error) {
                    console.error("Error retrieving encrypted password: ", error);
                    // Fallback to old method for backward compatibility
                    try {
                        const storedPassword = localStorage.getItem("password");
                        if (storedPassword) {
                            passSecret = JSON.parse(storedPassword);
                        }
                    } catch (fallbackError) {
                        console.error("Error with fallback password retrieval: ", fallbackError);
                    }
                }
                
                console.log("[NavigationMenu] Account details: ", accountDetails);
                console.log('[NavigationMenu] 🔑 Dispatching login action to context...');
                accountContextDispatch({type: 'login', signin: accountDetails, passSecret: passSecret})
                accountContextDispatch({type: 'tokens', tokens: accountDetails.tokens})
                console.log('[NavigationMenu] ✅ Login dispatched successfully');
            };

            initializeUserSession();
            if ((!sessionStorage.getItem('initialCollectionLoad') || sessionStorage.getItem('initialCollectionLoad') === "false") && db.collectedImages.count() === 0){
                console.log("Initial collection load");
                sessionStorage.setItem('initialCollectionLoad', 'true');
                db.collectedImages.clear();
                populateCollection(accountDetails.accountNo);
            } else {
                sessionStorage.setItem('initialCollectionLoad', 'true');
                sessionStorage.setItem('finishedCollectionLoad', 'true');
                collectionContextDispatch({type: 'finishedLoading'});
            }


            if (sessionStorage.getItem('initialCollectionLoad') || sessionStorage.getItem('initialCollectionLoad') === "true") {
                sessionStorage.setItem('finishedCollectionLoad', 'true');
                collectionContextDispatch({type: 'finishedLoading'});
            }
            if (sessionStorage.getItem('finishedCollectionLoad')) {
                collectionContextDispatch({type: 'finishedLoading'});
            }

            (async () => {
            if (!shouldBypass) {
                try {
                    await getTokens(accountDetails.accountNo).then(data => {
                        accountContextDispatch({type : "tokens", tokens: data.credits})
                    })
                } catch (error) {
                    console.error("Error fetching tokens for user: ", error)
                    // Don't set tokens to 0 on error - keep undefined to prevent false low credit warnings
                    console.log('[TOKEN_FETCH] Leaving tokens undefined to prevent false credit warnings')
                }
            } else {
                console.log("Offline mode - skipping token fetch");
            }
            if (!shouldBypass) {
                try {
                    await getSubscription(accountDetails.accountNo).then(data => {
                        console.log(`TARIFF ID: ${data.tariffId}`);
                        if (data.tariffId == "300000") {
                            localStorage.setItem('user_trial_sub', 'true')
                        } else {
                            localStorage.setItem('user_trial_sub', 'false')
                        }
                    })
                } catch (error) {
                    console.log(`ERROR retrieving subscription`);
                }
            } else {
                console.log("Offline mode - skipping subscription fetch");
            }
            })()
        } else {
            // No stored account found - this is a new user
            // Check if we're on the root path and should redirect to templates
            const currentPath = window.location.hash.replace('#', '') || window.location.pathname;
            console.log('[NavigationMenu] No stored account found. Current path:', currentPath);

            // Check for auto-login URL parameters (don't redirect during auto-login)
            const queryParams = new URLSearchParams(window.location.search);
            const hasAutoLoginParams = !!(queryParams.get('v') && queryParams.get('a') && queryParams.get('e'));

            if (!hasAutoLoginParams) {
                console.log('[NavigationMenu] User not logged in - redirecting to templates');
                navigate('/templates', { replace: true });
            }
        }
        ipcRenderer.send("pwa-log", "React - Navigation UseEffect End")
    },[])


    useEffect(() => {
        if (promptusAPIContext.activeCPU) {
            setServerCPU(true)
            setServerGPU(false);
            setServerCloud(false)
        }

        if (promptusAPIContext.activeGPU) {
            setServerGPU(true)
            setServerCPU(false);
            setServerCloud(false)
        }
        
        if (promptusAPIContext.online) {
            setServerCPU(false);
            setServerGPU(false);
        }
        setServerCloud(promptusAPIContext.online);
    }, [promptusAPIContext.online, promptusAPIContext.activeGPU, promptusAPIContext.activeCPU])

    useEffect(() => {
        // Add proper null check for enable_animations setting
        const getAnimationSetting = async () => {
            try {
                const setting = await db.settings.where("key").equals("enable_animations").first();
                if (setting && setting.hasOwnProperty('value')) {
                    setAnimations(setting.value);
                } else {
                    // Initialize the setting if it doesn't exist
                    await db.settings.put({ key: 'enable_animations', value: false });
                }
            } catch (error) {
                console.error("Error checking enable_animations setting:", error);
            }
        };
        
        getAnimationSetting();
    }, [generateStatus.loading])

    useEffect(() => {
        // Read preview_cosyui setting from database
        const getPreviewCosyUISetting = async () => {
            try {
                const setting = await db.settings.where("key").equals("preview_cosyui").first();
                if (setting && setting.hasOwnProperty('value')) {
                    setPreviewCosyUI(setting.value);
                } else {
                    // Initialize the setting if it doesn't exist
                    await db.settings.put({ key: 'preview_cosyui', value: false });
                }
            } catch (error) {
                console.error("Error checking preview_cosyui setting:", error);
            }
        };

        // Listen for changes from Settings component
        const handlePreviewCosyUIChange = (event) => {
            setPreviewCosyUI(event.detail);
        };

        getPreviewCosyUISetting();
        window.addEventListener('previewCosyUIChanged', handlePreviewCosyUIChange);

        // Cleanup listener on unmount
        return () => {
            window.removeEventListener('previewCosyUIChanged', handlePreviewCosyUIChange);
        };
    }, [])

    let fetching = false;
    const rebuildImages = async (accountNo) => {
        if (fetching){
            console.log("Fetching collection is already in progress");
            return;
        }
        
        fetching = true;
        
        // Check if a toggle operation is in progress with proper null check
        let toggleLocked = false;
        try {
            const toggleLock = await db.settings.where('key').equals('toggleLock').first();
            if (toggleLock && toggleLock.hasOwnProperty('value')) {
                toggleLocked = toggleLock.value;
            }
        } catch (error) {
            console.error("Error checking toggleLock setting:", error);
        }
        
        if (toggleLocked) {
            console.log("Toggle operation in progress, skipping rebuild");
            fetching = false;
            return;
        }
    
        try {
            console.log("Rebuilding images using paginated API for efficiency");
            
            // Get all local hashes first
            const localImages = await db.collectedImages.toArray();
            const localHashSet = new Set(localImages.map(img => img.hash));
            
            // Fetch server collection in batches
            const batchSize = 100;
            let pageNo = 1;
            let hasMore = true;
            let changed = false;
            const serverHashSet = new Set();
            const imagesToAdd = [];
            
            while (hasMore) {
                const response = await getCollectionPaginated(accountNo, batchSize, pageNo);
                
                if (response && response.data && response.data.length > 0) {
                    for (const image of response.data) {
                        serverHashSet.add(image.hash);
                        
                        // Check if this image needs to be added locally
                        if (!localHashSet.has(image.hash)) {
                            imagesToAdd.push(image);
                        }
                    }
                    
                    hasMore = response.data.length === batchSize;
                    pageNo++;
                } else {
                    hasMore = false;
                }
            }
            
            // Add new images to local collection
            if (imagesToAdd.length > 0) {
                console.log(`Adding ${imagesToAdd.length} new images to local collection`);
                changed = true;
                
                for (const image of imagesToAdd) {
                    const iCount = await db.collectedImages.count() + 1;
                    await db.collectedImages.put({
                        uid: image.uid,
                        imageID: iCount,
                        image: image.image,
                        seed: image.seed,
                        model: image.model,
                        hash: image.hash,
                        online: image.online || true,
                        tag: image.tag || "",
                        prompt: image.prompt,
                        public: image.public || false,
                        dataType: image.dataType || "image",
                        timestamp: Date.now()
                    });
                    await db.images.where('hash').equals(image.hash).modify({ inCollection: true });
                }
            }
            
            if (changed) {
                console.log("Changes detected, triggering reload");
                await db.reloadImages.put({ reload: "1" });
                await db.reloadImages.put({ reload: "2" });
            }
            
            console.log("Rebuild process completed");
            
        } catch (error) {
            console.error("Error during rebuild process:", error);
        } finally {
            fetching = false;
            collectionContextDispatch({ type: 'finishedLoading' });
        }
    };

    
    useEffect(() => {
        ipcRenderer.on("comfyUI_check_result", comfyUICheckRes);
    
        return () => {
            ipcRenderer.removeListener("comfyUI_check_result", comfyUICheckRes);
        };
    }, []);

    const comfyUICheck = () => {
        console.log("Checking if ComfyUI directory exists");
        
        ipcRenderer.send("check-comfyui", "yo")
    }
    
    const comfyUICheckRes = (e, showComfyOut) => {
        console.log(`Comfy Check Result ${JSON.stringify(showComfyOut)}`);

        setComfyVisibility(showComfyOut)
    }

    // Auto-configure detected servers (streamlined version of Settings.jsx saveApiSettings)
    const autoConfigureServer = async (serverType, serverUrl) => {
        try {
            const serverKey = `${serverType}_${serverUrl}`;

            // // Check if this server has already been auto-configured
            // if (autoConfiguredServers.has(serverKey)) {
            //     console.log(`[AUTO_CONFIG] Server ${serverType} at ${serverUrl} already auto-configured, skipping`);
            //     return;
            // }

            console.log(`[SERVER_STATUS_AUTO_CONFIG] Configuring ${serverType} server at ${serverUrl}`);

            // Unified configuration pattern for all servers
            if (serverType === "gpu") {
                // Save GPU server to local database
                await db.settings.put({key: 'local_gpu', value: serverUrl});
                promptusAPIDispatch({type: 'setActiveGPU', server: true});
                console.log(`[SERVER_STATUS_AUTO_CONFIG] ✅ Saved GPU server: ${serverUrl}`);

            } else if (serverType === "cpu") {
                // Save CPU server to local database
                await db.settings.put({key: 'local_cpu', value: serverUrl});
                promptusAPIDispatch({type: 'setActiveCPU', server: true});
                console.log(`[SERVER_STATUS_AUTO_CONFIG] ✅ Saved CPU server: ${serverUrl}`);

            } else if (serverType === "cosy") {
                // Save Cosy server to local database (same pattern as GPU/CPU)
                await db.settings.put({key: 'local_cosy', value: serverUrl});
                promptusAPIDispatch({type: 'setActiveCosy', server: true});
                console.log(`[SERVER_STATUS_AUTO_CONFIG] ✅ Saved Cosy server: ${serverUrl}`);

                // // ADDITIONAL steps for Cosy only (api_host configuration)
                // await db.settings.put({key: 'api_host', value: serverUrl});
                // // promptusAPIDispatch({type: 'offline'});
                // promptusAPIDispatch({type: 'setHost', host: serverUrl});
                // promptusAPIDispatch({type: 'setActiveCosy', server: true});
                // console.log(`[SERVER_STATUS_AUTO_CONFIG] ✅ Activated Cosy server as api_host: ${serverUrl}`);

            } else {
                console.log(`[SERVER_STATUS_AUTO_CONFIG] Unknown server type: ${serverType}`);
                return;
            }

            // NEW: Also fetch and cache models when server is auto-configured
            console.log(`[SERVER_STATUS_AUTO_CONFIG] Fetching models for ${serverType} server...`);
            try {
                const models = await fetchAndCacheModelsFromServer(serverType, serverUrl);
                console.log(`[SERVER_STATUS_AUTO_CONFIG] ✅ Cached ${models.length} models for ${serverType} server`);

                // Store last successful model fetch time
                await db.settings.put({
                    key: `${serverType}_models_last_updated`,
                    value: new Date().toISOString()
                });

            } catch (modelError) {
                console.warn(`[SERVER_STATUS_AUTO_CONFIG] ⚠️ Failed to fetch models for ${serverType}:`, modelError);
                // Don't fail the entire configuration if model fetching fails
            }

            // // Mark as auto-configured for all server types
            // setAutoConfiguredServers(prev => new Set([...prev, serverKey]));
        } catch (error) {
            console.error(`[SERVER_STATUS_AUTO_CONFIG] ❌ Error configuring ${serverType} server:`, error);
        }
    };

    const serverStatusCheck = async () => {
        let rawData = null;
        try {
            // Add timeout to prevent hanging requests
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 2000); // 2 second timeout

            try {
                const response = await axios.get(`http://localhost:7412/status`, {
                    signal: controller.signal,
                    timeout: 2000 // Additional axios timeout as backup
                });   
                clearTimeout(timeoutId);
                rawData = response.data;
            } catch (error) {
                // Reset all states to null first
                setActiveGPU(null);
                setActiveCPU(null);
                setActiveComfyUI(null);
                setActiveCosy(null);
                setActiveHorde(null);
                setActiveCWorker(null);
                clearTimeout(timeoutId);
                if (error.code === 'ECONNREFUSED' || error.code === 'ERR_NETWORK' || error.name === 'AbortError') {
                    return;
                }
                if (error.response?.status !== 404) {
                    console.warn("Server status check failed:", error.message);
                }
                return;
            }

            if (!rawData) return;

            console.log('[SERVER_STATUS] Received data:', rawData);

            const statuses = Array.isArray(rawData) ? rawData : [];

            console.log('[SERVER_STATUS] Parsed statuses:', statuses);

            // Reset all states to null first
            setActiveGPU(null);
            setActiveCPU(null);
            setActiveComfyUI(null);
            setActiveCosy(null);
            setActiveHorde(null);
            setActiveCWorker(null);

            // Build detected servers object for future use (only include 'ready' servers)
            const newDetectedServers = {};

            // Iterate through array of objects with new format: {name, url, status}
            statuses.forEach(serverObj => {
                const { name: serverType, url: serverUrl, status: serverStatus } = serverObj;

                if (!serverType || !serverUrl) {
                    console.warn('[SERVER_STATUS] Invalid server object:', serverObj);
                    return;
                }

                console.log('[SERVER_STATUS] Found server:', serverType, 'at', serverUrl, 'status:', serverStatus);

                // Only add to detectedServers if status is 'ready'
                const isReady = serverStatus === 'ready';

                switch (serverType) {
                    case 'gpu':
                        setActiveGPU(serverStatus);
                        if (isReady) {
                            newDetectedServers[serverType] = serverUrl;
                            autoConfigureServer(serverType, serverUrl);
                        }
                        break;
                    case 'cpu':
                        setActiveCPU(serverStatus);
                        if (isReady) {
                            newDetectedServers[serverType] = serverUrl;
                            autoConfigureServer(serverType, serverUrl);
                        }
                        break;
                    case 'comfyui':
                        setActiveComfyUI(serverStatus);
                        break;
                    case 'cosy':
                        setActiveCosy(serverStatus);
                        if (isReady) {
                            newDetectedServers[serverType] = serverUrl;
                            autoConfigureServer(serverType, serverUrl);
                        }
                        break;
                    case 'horde':
                        setActiveHorde(serverStatus);
                        break;
                    case 'cworker':
                        setActiveCWorker(serverStatus);
                        break;
                    default:
                        console.log('[SERVER_STATUS] Unknown server type:', serverType);
                }
            });

            // Compare with previous servers using ref (synchronous, avoids closure issues)
            const prevServers = previousDetectedServersRef.current;
            const disappearedServers = Object.keys(prevServers).filter(
                serverType => !newDetectedServers[serverType]
            );
            const appearedServers = Object.keys(newDetectedServers).filter(
                serverType => !prevServers[serverType]
            );

            // Update ref for next comparison
            previousDetectedServersRef.current = { ...newDetectedServers };

            // Update state
            setDetectedServers(newDetectedServers);
            console.log('[SERVER_STATUS] Updated detected servers:', newDetectedServers);

            // Handle servers that went offline
            if (disappearedServers.length > 0) {
                console.log('[SERVER_STATUS] 🔴 Servers went offline:', disappearedServers);
                cleanupOfflineServerCache(newDetectedServers)
                    .then(deletedCount => {
                        if (deletedCount > 0) {
                            console.log(`[SERVER_STATUS] ✅ Cleaned up ${deletedCount} cache entries for offline servers`);
                        }
                    })
                    .catch(error => {
                        console.warn('[SERVER_STATUS] Error cleaning up offline server cache:', error);
                    });
            }

            // Handle NEW servers that just came online
            if (appearedServers.length > 0) {
                console.log('[SERVER_STATUS] 🟢 New servers detected:', appearedServers);
            }

            // Share detected servers with GenerateContext for use by other components
            generateStatusDispatch({ type: 'setServerStatus', serverStatus: newDetectedServers });

            // Background model cache refresh for detected servers
            if (Object.keys(newDetectedServers).length > 0) {
                try {
                    const lastRefresh = await db.settings.get({key: 'models_last_refresh'});
                    const timeSinceRefresh = lastRefresh?.value
                        ? Date.now() - new Date(lastRefresh.value).getTime()
                        : Infinity;

                    const CACHE_REFRESH_INTERVAL = 5 * 60 * 1000; // 5 minutes
                    const shouldRefreshImmediately = appearedServers.length > 0;

                    if (timeSinceRefresh > CACHE_REFRESH_INTERVAL || shouldRefreshImmediately) {
                        if (shouldRefreshImmediately) {
                            console.log('[SERVER_STATUS] 🟢 Immediately refreshing model cache for new servers:', appearedServers);
                        } else {
                            console.log('[SERVER_STATUS] Refreshing model cache for detected servers...');
                        }

                        refreshModelCache(null, newDetectedServers, { parallel: true })
                            .then(results => {
                                console.log(`[SERVER_STATUS] Model cache refresh completed: ${results.successful}/${results.attempted} servers`);

                                db.settings.put({
                                    key: 'models_last_refresh',
                                    value: new Date().toISOString()
                                });

                                if (shouldRefreshImmediately) {
                                    console.log('[SERVER_STATUS] 🔄 Emitting models_cache_refreshed event with servers:', newDetectedServers);
                                    eventBus.emit('models_cache_refreshed', newDetectedServers);
                                }
                            })
                            .catch(refreshError => {
                                console.warn('[SERVER_STATUS] Model cache refresh failed:', refreshError);
                            });

                        cleanupOfflineServerCache(newDetectedServers)
                            .catch(cleanupError => {
                                console.warn('[SERVER_STATUS] Cache cleanup failed:', cleanupError);
                            });
                    } else {
                        console.log(`[SERVER_STATUS] Skipping cache refresh (last refresh ${Math.round(timeSinceRefresh / 1000)}s ago)`);
                    }
                } catch (cacheError) {
                    console.warn('[SERVER_STATUS] Error during background model cache operations:', cacheError);
                }
            }
        } catch (error) {
            console.error("[SERVER_STATUS] Error processing server status data:", error);
            console.error("[SERVER_STATUS] Raw data that caused error:", rawData);

            setActiveGPU(null);
            setActiveCPU(null);
            setActiveComfyUI(null);
            setActiveCosy(null);
            setActiveHorde(null);
            setActiveCWorker(null);
            setDetectedServers({});
        }
    }

    // compareVersions(a, b) -> 1 if a>b, -1 if a<b, 0 if equal
    const compareVersions = (a, b) => {
        console.log(`[VERSION CHECK] Checking versions of a: ${a} and b: ${b}`);
        
        const A = a.split('.').map(Number);
        const B = b.split('.').map(Number);
        const len = Math.max(A.length, B.length);
      
        for (let i = 0; i < len; i++) {
          const x = A[i] || 0;
          const y = B[i] || 0;
          if (x > y) return 1;
          if (x < y) return -1;
        }
        return 0;
      }

    const POLLING_INTERVAL = 10000; // Poll every 10 seconds
  
    // Store the previous collection count in a ref
    const previousCollectionCount = useRef(0);
    
    // Keep generateStatusRef updated with latest value
    useEffect(() => {
        generateStatusRef.current = generateStatus;
    }, [generateStatus]);
    
    useEffect(() => {
        console.log('[POLLING] Setting up new polling interval due to dependency change:', {
            generateStatusExists: !!generateStatus,
            accountLoggedIn: accountContext.loggedIn,
            accountNo: accountContext.accountDetails?.accountNo,
            hasTokens: accountContext.tokens !== undefined,
            tokenCount: accountContext.tokens
        });

        const poll = async () => {
            console.log('[POLLING] ========== POLL CYCLE START ==========');
            console.log('[POLLING] Current accountContext state:', {
                loggedIn: accountContext.loggedIn,
                accountNo: accountContext.accountDetails?.accountNo,
                tokens: accountContext.tokens,
                hasAccountDetails: !!accountContext.accountDetails,
                accountDetailsKeys: Object.keys(accountContext.accountDetails || {}),
                timestamp: Date.now()
            });

            let updatedCredits = accountContext.tokens;

            if (!shouldBypass) {
                try {
                    await getTokens(accountContext.accountDetails.accountNo).then(data => {
                        updatedCredits = data.credits
                        accountContextDispatch({type : "tokens", tokens: data.credits})
                    })
                } catch (error) {
                    console.error("Error fetching tokens for user: ", error)
                    // Don't set tokens to 0 on error - keep undefined to prevent false low credit warnings
                    console.log('[TOKEN_FETCH] Leaving tokens undefined to prevent false credit warnings')
                }
            } else {
                console.log("Offline mode - skipping token fetch");
            }

            await serverStatusCheck();

            // Get fresh generateStatus data directly - don't rely on ref which may be stale
            const currentGenerateStatus = generateStatus || {};
            const allJobs = currentGenerateStatus.jobs || {};

            console.log('[NAVIGATION POLL] Current jobs state:', Object.keys(allJobs).map(id =>
                `${id}: ${allJobs[id]?.status || 'unknown'} (${allJobs[id]?.totalImages || 0}/${allJobs[id]?.count || 0})`
            ));

            // Filter to only truly active jobs (generating or pending status)
            const activeJobs = Object.fromEntries(
                Object.entries(allJobs).filter(([id, job]) =>
                    job.status === 'generating' || job.status === 'pending'
                )
            );

            console.log('[NAVIGATION POLL] Filtered active jobs:', Object.keys(activeJobs).map(id =>
                `${id}: ${activeJobs[id]?.status || 'unknown'}`
            ));

            // Clean up stale pending jobs
            const pendingJobsData = localStorage.getItem('pending_jobs');
            if (pendingJobsData) {
                try {
                    const pendingJobs = JSON.parse(pendingJobsData);
                    let hasChanges = false;

                    // Check each pending job
                    for (const [uid, jobData] of Object.entries(pendingJobs.jobs || {})) {
                        // If job is not in all jobs and is older than 2 minutes, remove it
                        if (!allJobs[uid]) {
                            const jobAge = Date.now() - (jobData.timestamp || 0);
                            if (jobAge > 120000) { // 2 minutes
                                console.log(`[PENDING CLEANUP] Removing stale pending job ${uid} (age: ${Math.round(jobAge/1000)}s)`);
                                delete pendingJobs.jobs[uid];
                                hasChanges = true;
                            }
                        } else {
                            // Also check if the job is in a completed/failed state
                            const job = allJobs[uid];
                            if (job && (job.status === 'error' || job.status === 'done' || job.status === 'completed' || job.status === 'cancelled')) {
                                console.log(`[PENDING CLEANUP] Removing completed/failed job ${uid} (status: ${job.status})`);
                                delete pendingJobs.jobs[uid];
                                hasChanges = true;
                            }
                        }
                    }

                    // Save cleaned up pending jobs
                    if (hasChanges) {
                        if (Object.keys(pendingJobs.jobs).length === 0) {
                            localStorage.removeItem('pending_jobs');
                            console.log('[PENDING CLEANUP] All pending jobs cleared');
                        } else {
                            localStorage.setItem('pending_jobs', JSON.stringify(pendingJobs));
                            console.log(`[PENDING CLEANUP] ${Object.keys(pendingJobs.jobs).length} pending jobs remaining`);
                        }
                    }
                } catch (e) {
                    console.error('[PENDING CLEANUP] Error cleaning pending jobs:', e);
                }
            }

            const collectionCount = await db.collectedImages.count();
            const accountDetails = await db.account.where("key").equals("accountDetails").first();

            if (accountDetails && accountDetails.value && accountDetails.value.accountNo) {
                if (collectionCount !== previousCollectionCount.current) {
                    console.log("POLLING FOR CHANGES");
                } else {
                    console.log("No changes in collection count, skipping rebuild.");
                }
            }

            // Check for placeholder cleanup - use fresh data instead of stale ref
            const activeJobIds = Object.keys(activeJobs);
            const activeJobsCount = activeJobIds.length;
            console.log(`[NAVIGATION POLL] Found ${activeJobsCount} active jobs:`, activeJobIds);

            if (activeJobsCount === 0) {
                console.log('[NAVIGATION POLL] No active jobs detected - triggering placeholder cleanup');
                eventBus.emit('run_placeholderCleanup');
            } else {
                console.log(`[NAVIGATION POLL] ${activeJobsCount} jobs still active, skipping cleanup`);
            }

            comfyUICheck();
            previousCollectionCount.current = collectionCount; // Update the previous count after polling


            // Version check with proper error handling for dev APIs
            try {
                console.log('[VERSION CHECK] Retrieving latest released version info');
                const responseVersion = await getVersionFromAPI();

                if (responseVersion && Array.isArray(responseVersion) && responseVersion.length > 0 && responseVersion[0]?.versionNumber) {
                    console.log('[VERSION CHECK] Retrieved version info: ', responseVersion);
                    // compareVersions(a, b) -> 1 if a>b, -1 if a<b, 0 if equal
                    const isUpdateAvailable = compareVersions(process.env.REACT_APP_VERSION, responseVersion[0].versionNumber) === -1;

                    let productionVersion = false;
                    if (electronBridge.isElectron) {
                        productionVersion = true;
                    } else if (window.location.href.includes('login')) {
                        productionVersion = true;
                    }
                    console.log('[VERSION CHECK] Update check response: ', isUpdateAvailable, ' and prod: ', productionVersion);

                    if (isUpdateAvailable && productionVersion) {
                        const newVersion = responseVersion[0].versionNumber;

                        // Check if this version was already dismissed
                        const dismissedVersion = localStorage.getItem('dismissedUpdateVersion');
                        const dismissedThisSession = sessionStorage.getItem('updateDismissedThisSession');

                        // Only show if not dismissed and not already showing
                        if (dismissedVersion !== newVersion && !dismissedThisSession && !updateAvailable) {
                            console.log('[VERSION CHECK] Setting update notification state');
                            setLatestVersion(newVersion);
                            setUpdateAvailable(true);
                            setUpdateDismissed(false);
                        } else {
                            console.log('[VERSION CHECK] Update already dismissed or showing');
                        }
                    } else if (!isUpdateAvailable) {
                        // Reset states when no update is available
                        setUpdateAvailable(false);
                        setUpdateDismissed(false);
                    }
                } else {
                    console.warn('[VERSION CHECK] No valid version data received from API - skipping version check');
                }
            } catch (error) {
                console.error('[VERSION CHECK] Error during version check:', error);
                // Continue execution silently without breaking the app
            }

            // Dynamic credit warning check
            console.log('[CREDIT_CHECK] ========== CREDIT CHECK START ==========');
            console.log('[CREDIT_CHECK] Pre-check state:', {
                accountLoggedIn: accountContext.loggedIn,
                creditsDataLoading,
                hasAccountDetails: !!accountContext.accountDetails,
                accountNo: accountContext.accountDetails?.accountNo,
                tokens: accountContext.tokens,
                hasMonthlyCreditsData: !!monthlyCreditsData,
                lowCreditWarningShown: lowCreditWarningShown.current
            });

            if (accountContext.loggedIn && !creditsDataLoading) {
                console.log('[CREDIT_CHECK] Conditions met - proceeding with credit check');

                // Fix: Ensure tokens are properly loaded before checking credits
                if (!accountContext.accountDetails?.accountNo ||
                    accountContext.tokens === undefined ||
                    accountContext.tokens === null ||
                    accountContext.tokens === 0) {
                    console.log('[CREDIT_CHECK] Tokens not properly loaded or account incomplete - skipping credit check to prevent false warnings');
                    console.log('[CREDIT_CHECK] Current state:', {
                        hasAccountNo: !!accountContext.accountDetails?.accountNo,
                        tokens: accountContext.tokens,
                        tokensType: typeof accountContext.tokens,
                        reason: accountContext.tokens === 0 ? 'tokens_is_zero' :
                               accountContext.tokens === undefined ? 'tokens_undefined' :
                               accountContext.tokens === null ? 'tokens_null' : 'account_incomplete'
                    });
                    return;
                }
                
                // Calculate dynamic threshold
                let creditThreshold = 250; // fallback
                let thresholdMessage = `Only ${updatedCredits} credits remain`;

                if (monthlyCreditsData?.creditsAllowance) {
                    creditThreshold = Math.floor(monthlyCreditsData.creditsAllowance * 0.25);
                    thresholdMessage = `Only 25% of your monthly credits remain (${updatedCredits}/${monthlyCreditsData.creditsAllowance})`;
                }

                console.log('[CREDIT_CHECK] Credit Threshold: ', creditThreshold , 'and message to be shown: | ',thresholdMessage);
                if (updatedCredits <= creditThreshold) {
                    // Add basic spam prevention
                    if (!lowCreditWarningShown.current) {
                        Swal.fire({
                            title: thresholdMessage,
                            text: 'Subscribe now and instantly get more credits',
                            confirmButtonText: 'Keep Creating',
                            showDenyButton: true,
                            denyButtonText: 'Get More Credits',
                            icon: 'info',
                            confirmButtonColor: '#190A4E',
                            denyButtonColor: '#FFB02E'
                        }).then((result) => {
                            if (result.isDenied) {
                                navigate('/profile?openCredits=true');
                            }
                        });
                        lowCreditWarningShown.current = true;
                    }
                } else if (updatedCredits > creditThreshold) {
                    // Reset warning flag when credits go above threshold
                    lowCreditWarningShown.current = false;
                }
            } else {
                console.log('[CREDIT_CHECK] Skipping credit check - conditions not met:', {
                    reasonNotLoggedIn: !accountContext.loggedIn,
                    reasonCreditsDataLoading: creditsDataLoading,
                    accountContextState: {
                        loggedIn: accountContext.loggedIn,
                        hasAccountDetails: !!accountContext.accountDetails,
                        accountNo: accountContext.accountDetails?.accountNo,
                        tokens: accountContext.tokens
                    }
                });
            }

        };

        pollingRef.current = setInterval(poll, POLLING_INTERVAL);
        console.log('[POLLING] New polling interval created with ID:', pollingRef.current);

        return () => {
            console.log('[POLLING] Cleaning up polling interval:', pollingRef.current);
            clearInterval(pollingRef.current);
        };
    }, [generateStatus, accountContext.loggedIn, accountContext.accountDetails?.accountNo, shouldBypass]); // Include account data so poll function gets recreated when login state changes

    // Run server status check immediately on mount
    useEffect(() => {
        console.log('[SERVER_STATUS] Running initial server check on mount');
        serverStatusCheck();
    }, []);

    // useEffect(() => {
    //     let interval;
    //     if (sessionStorage.getItem('finishedCollectionLoad') || collectionContext.finishedLoading == true) {
    //         interval = setInterval(async () => {
    //                 const collectionCount = await db.collectedImages.count();
    //                 const accountDetails = await db.account.where("key").equals("accountDetails").first();
    //                 if (accountDetails && accountDetails.value && accountDetails.value.accountNo) {
    //                     if (collectionCount > 0) {
    //                         console.log("POLLING FOR CHANGES");
    //                         try {
    //                             await rebuildImages(accountDetails.value.accountNo);
    //                             collectionContextDispatch({type: 'finishedLoading'});
    //                         } catch (error) {
    //                             console.error("An error occurred during the rebuild process:", error);
    //                         }
    //                     } else if (collectionCount === 0) {
    //                         console.log("No images in the collection, Populating collection");
    //                         populateCollection(accountDetails.value.accountNo);
    //                     }
    //                 }

    //                 comfyUICheck()
    //         }, POLLING_INTERVAL);
    //     }

    //     return () => clearInterval(interval);
    // }, [db,update,collectionContext.finishedLoading]); // Adjust dependencies based on actual variables that affect the effect

    useEffect(() => {
        if (generateStatus.undeliveredImages) {
            if (generateStatus.checkingUndeliveredImages) {
                setUndeliveredStatus("Undelivered images found!");
            } else if (generateStatus.retrievingUndeliveredImages) {
                setUndeliveredStatus("Retrieving undelivered images...");
            } else {
                setUndeliveredStatus("Checking for undelivered images...");
            }   
        }
    }, [generateStatus.undeliveredImages, generateStatus.checkingUndeliveredImages, generateStatus.retrievingUndeliveredImages]);

    // Check for pending jobs on startup and emit recovery event
    useEffect(() => {
        const checkPendingJobs = async () => {
            try {
                // Check for any pending jobs (new or legacy format)
                const pendingJobsData = localStorage.getItem('pending_jobs');
                const legacyWorkload = localStorage.getItem('remember_workload');
                
                let hasPendingJobs = false;
                
                // Check new format
                if (pendingJobsData) {
                    try {
                        const parsed = JSON.parse(pendingJobsData);
                        if (parsed.jobs && Object.keys(parsed.jobs).length > 0) {
                            hasPendingJobs = true;
                        }
                    } catch (e) {
                        console.error('Error parsing pending_jobs:', e);
                    }
                }
                
                // Check legacy format
                if (!hasPendingJobs && legacyWorkload) {
                    try {
                        const workloadDetails = JSON.parse(legacyWorkload);
                        if (workloadDetails?.active && workloadDetails?.uid) {
                            hasPendingJobs = true;
                            setPendWorkDetails(workloadDetails);
                            setPendingWorkload(true);
                        }
                    } catch (e) {
                        console.error('Error parsing legacy workload:', e);
                    }
                }
                
                // If we have pending jobs and API is ready, trigger recovery
                if (hasPendingJobs && apiState.host && apiState.host.includes("api")) {
                    console.log('[NAV MENU] Found pending jobs, triggering recovery');
                    // Emit event to trigger job recovery
                    eventBus.emit('startJobRecovery', { apiState });
                    
                    // Use the new recovery service
                    await checkForPendingJobs(apiState, generateStatusDispatch);
                }
            } catch (error) {
                console.error('Error checking for pending jobs:', error);
            }
        };
        
        if (apiState.host) {
            checkPendingJobs();
        }
    }, [apiState.host]);

    // Timer cleanup handled by job recovery service now
    useEffect(() => {
        // Listen for job completion events from recovery service
        const handleJobRecovered = (data) => {
            if (data.uid && pendWorkDetails.uid === data.uid) {
                setPendingWorkload(false);
                setPendWorkDetails({});
                setPendWorkProgress(0);
            }
        };
        
        eventBus.on('jobRecovered', handleJobRecovered);
        return () => eventBus.off('jobRecovered', handleJobRecovered);
    }, [pendWorkDetails.uid]);

    // Old fetchPendingJob function removed - now handled by jobRecoveryService.js

    const cancelPendingWorkload = () => {
        console.log("Cancelling pending workload");
        setPendingWorkload(false);
        setPendWorkDetails({});
        setPendWorkProgress(0);
        // Clear from new multi-job format
        eventBus.emit('cancelJobRecovery', { uid: pendWorkDetails.uid });
        // Clear legacy format
        localStorage.setItem('remember_workload', JSON.stringify({
            active: false,
            uid: "",
            count: 0,
            totalImage: 0,
            num: 0,
        }));
    }

    const handleCancelJob = async (jobId) => {
        console.log(`[CANCEL] Cancelling job ${jobId}`);

        // 1. Set job status to cancelling via new context action
        generateStatusDispatch({ type: 'cancelJob', uid: jobId });

        // 2. Call appropriate API to cancel server-side
        try {
            if (jobId.includes("-")) {
                await cancelCosyJob(jobId, apiState, generateStatusDispatch);
            } else {
                await cancelJob(jobId, accountContext.accountDetails.accountNo, generateStatusDispatch);
            }
            console.log(`[CANCEL] Successfully cancelled job ${jobId}`);
        } catch (error) {
            console.error(`[CANCEL] API cancel failed for job ${jobId}:`, error);
        }
    };

    const handleLoginSuccess = async (data) => {
        if (!data.message) {
            ipcRenderer.send("pwa-log", `Auto Login account details: ${JSON.stringify(data)}`);
            console.log(`Auto Login account details: `, data);
            

            setAccount(data.account);
            setAutoLoggedIn(true);
            setAccountNo(data.account.accountNo);
            setLoggedIn(true);

            accountContextDispatch({ type: 'login', signin: data.account, passSecret: "" });

            localStorage.setItem("account", JSON.stringify(data.account));
            db.account.put({ key: 'accountDetails', value: data.account });

            try {
                getTokens(data.account.accountNo).then(data => {
                    accountContextDispatch({ type: "tokens", tokens: data.credits });
                });
            } catch (error) {
                console.error("Error fetching tokens during login: ", error);
                // Don't set tokens to 0 on error - keep undefined to prevent false low credit warnings
                console.log('[LOGIN_TOKEN_FETCH] Leaving tokens undefined to prevent false credit warnings');
            }

            // Store session keys in sessionStorage if they exist
            if (data.api_key) {
                window.sessionStorage.setItem("apiKey", data.api_key);
                // Also store in localStorage for persistence until expiry
                window.localStorage.setItem("apiKey", data.api_key);
            }
            
            if (data.api_key_expiry) {
                window.sessionStorage.setItem("apiKeyExpiry", data.api_key_expiry);
                // Also store expiry in localStorage
                window.localStorage.setItem("apiKeyExpiry", data.api_key_expiry);
            }
            if (electronBridge.isElectron) {
                console.log(`USING ELECTRON FOR INI ACCOUNTNO: ${JSON.stringify(data)}`);
                ipcRenderer.send("ini-accountNo", data.account.accountNo, data.account.alias, data.api_key)
            }

            fetchWHMCSData();

            if (!sessionStorage.getItem('initialCollectionLoad') || sessionStorage.getItem('initialCollectionLoad') === "false") {
                // Use the more efficient populateCollection function
                await populateCollection(data.account.accountNo);
            }

            // Emit login success event to close any open LoginModals
            console.log('[NavigationMenu] Auto-login successful - emitting user-logged-in event');
            eventBus.emit('user-logged-in', { account: data.account });
        }
    };

    const removeQueryString = () => {
        const url = new URL(window.location.href);
        url.search = ''; // Remove the query string
        window.history.replaceState({}, '', url.toString()); // Replace the URL without reloading
    };

    // Step 2a: Listen for data sent from Electron
    useEffect(() => {
        ipcRenderer.on('auth-url-data', (_, data) => {
            console.log(`Auth url data Electron function ran: ${data}`);
            ipcRenderer.send("pwa-log", `Auth url data Electron function ran: ${data}`)
            setAuthParams(data); // Will trigger useEffect below
        });

        return () => {
        ipcRenderer.removeAllListeners('auth-url-data');
        };
    }, []);

    // Step 2a: Listen for payment status data sent from Electron
    // Using useLayoutEffect for faster response to deep links
    useLayoutEffect(() => {
        ipcRenderer.on('payment-status-electron', (_, data) => {
            console.log(`Payment Status Electron function ran:`, data);
            ipcRenderer.send("pwa-log", `Payment Status Electron function ran: ${JSON.stringify(data)}`)
            // Navigate to payment status page with cs parameter
            if (data.cs) {
                navigate(`/payment-status?cs=${data.cs}`);
            }
        });

        return () => {
        ipcRenderer.removeAllListeners('payment-status-electron');
        };
    }, [navigate]);

    // Check for URL parameters in browser environment on mount
    useEffect(() => {
        // Only run in browser environment on initial mount
        if (!isElectronEnv) {
            const queryParams = new URLSearchParams(window.location.search);
            const v = queryParams.get('v');
            const a = queryParams.get('a');
            const e = queryParams.get('e');
            
            // If OAuth parameters exist, set authParams to trigger auto-login
            if (v && a && e) {
                console.log('Browser OAuth parameters detected:', { v, a, e });
                setAuthParams({ v, a, e });
            }
        }
    }, []); // Empty dependency array - only run once on mount

    useEffect(() => {
        if (!authParams || autoLoginCalled.current) {
            return; // Exit early if already called
        }

        // Set the ref to true to prevent future calls
        autoLoginCalled.current = true;

        // Set authenticating flag to prevent session expiry checks during auto login
        accountContextDispatch({ type: 'setAuthenticating', value: true });

        // Function to fetch the IP and source
        const fetchData = async () => {
            const ip = await fetchIP();  // Fetch the IP address
            const source = await fetchSource();  // Fetch the source URL
            let data = null
            const queryParams = new URLSearchParams(window.location.search);
            const autoLoginError = queryParams.get('err');

            if (typeof authParams == 'object') {
                data = {
                    v: authParams.v,
                    e: authParams.e,
                    a: authParams.a,
                    source,
                    ip_address: ip
                  }; 
            } else {
                // Get query parameters from the URL
                const verificationToken = queryParams.get("v");
                const encodedEmailAddress = queryParams.get("e");
                const accountNo = queryParams.get("a");

                data = {
                    v: verificationToken,
                    e: encodedEmailAddress,
                    a: accountNo,
                    source: source ,
                    ip_address: ip
                };
            }



            try {
                // Perform autoLogin
                const response = await autoLogin(data);
                await handleLoginSuccess(response);  // Pass the data to the new function
                setAuthParams(null)

            } catch (error) {
                console.error("Error during login:", error);
            } finally {
                // Clear authenticating flag after auto login completion (success or failure)
                accountContextDispatch({ type: 'setAuthenticating', value: false });
            }

            // if ((autoLoginError !== "") && (autoLoginError !== null)) navigateTo += "?err="+ autoLoginError;

            removeQueryString();
        };

        fetchData();  // Call the fetchData function
    }, [authParams]);


    const fetchIP = async () => {
        if (shouldBypass) {
            console.log('Offline mode - skipping IP fetch');
            return 'offline';
        }

        let ip = '';
        try {
            const response = await fetch('https://api.ipify.org/?format=text');
            ip = await response.text();
            console.log("IP ADDRESS ", ip);
            return ip;  // Returning the IP address from the function
        } catch (error) {
            console.error('Error fetching IP address: ', error);
            return null;  // Returning null in case of error
        }
    };

    const fetchSource = async  () => {
        const fullUrl = window.location.href;  // Get the full URL
        return fullUrl.split('/').slice(0, 3).join('/');
    };

    const fetchWHMCSData = () => {
        if (accountContext.accountDetails.accountNo) {
            getWhmcsData(accountContext.accountDetails.accountNo).then(async (data) => {
                console.log("WhmcsData: ", data)
                setShowHostingDetails(false)
                if (data && data.whmcsOrderId > 0) {
                    setShowHostingDetails(true)
                    setHostingCreated(data.dateCreated);
                    setHostingDomain(data.domain);
                    setHostingStatus(data.whmcsOrderStatus);
                    setHostingSetupInvoice(data.whmcsInvoiceId);
                    setHostingSetupInvoiceStatus(data.whmcsPaymentStatus);
                    setHostingSetupInvoiceAmount(data.whmcsInitialAmount);
                    setHostingOrderNumber(data.whmcsOrderNumber)

                }
            });
        }
    }

    // Replace drag and drop handlers with move up/down functions
    const handleMoveUp = (index) => {
        if (index <= 0) return; // Already at the top
        
        const items = [...menuState.menuItems];
        // Swap the item with the one above it
        [items[index], items[index - 1]] = [items[index - 1], items[index]];
        
        menuDispatch({ type: 'REORDER', payload: items });
        // Save changes without exiting edit mode
        setTimeout(() => menuDispatch({ type: 'SAVE_WITHOUT_EXIT' }), 100);
    };

    const handleMoveDown = (index) => {
        if (index >= menuState.menuItems.length - 1) return; // Already at the bottom
        
        const items = [...menuState.menuItems];
        // Swap the item with the one below it
        [items[index], items[index + 1]] = [items[index + 1], items[index]];
        
        menuDispatch({ type: 'REORDER', payload: items });
        // Save changes without exiting edit mode
        setTimeout(() => menuDispatch({ type: 'SAVE_WITHOUT_EXIT' }), 100);
    };

    const toggleEditMode = () => {
        menuDispatch({ type: 'TOGGLE_EDIT_MODE' });
    };

    const resetMenuOrder = () => {
        menuDispatch({ type: 'RESET_ORDER' });
    };

    // Check session expiry periodically
    useEffect(() => {
        // Function to check if session has expired
        const checkSessionExpiry = () => {
            const apiKeyExpiry = window.localStorage.getItem('apiKeyExpiry');
            const apiKey = window.localStorage.getItem('apiKey');

            // Skip session check if user is in the process of logging out or authenticating
            if (accountContext.isLoggingOut || accountContext.isAuthenticating) {
                console.log('Skipping session check - user is logging out or authenticating');
                return;
            }

            // Only show popup if user was previously logged in (avoid showing on app startup)
            if (!apiKey && accountContext.loggedIn) {
                // Show user-friendly alert
                window.localStorage.removeItem('apiKey');
                window.localStorage.removeItem('apiKeyExpiry');

                Swal.fire({
                    title: 'Session Expired',
                    text: 'Your session has expired. Please log in again.',
                    icon: 'info',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#FFB02E'
                }).then(() => {
                    // Navigate to profile page for re-login
                    navigate('/profile');
                });

                // Trigger logout
                accountContextDispatch({ type: 'logout' });

                // const expiryDate = new Date(apiKeyExpiry);
                // const now = new Date();

                // // Check if session has expired
                // if (now >= expiryDate) {
                //     // Clear session storage
                // }
            }
        };
        
        // Check immediately on mount (with a longer delay to allow for auto login to complete)
        const initialCheckTimeout = setTimeout(checkSessionExpiry, 5000);

        // Check every minute
        const intervalId = setInterval(checkSessionExpiry, 60000); // 60 seconds

        // Cleanup interval and timeout on unmount
        return () => {
            clearInterval(intervalId);
            clearTimeout(initialCheckTimeout);
        };
    }, [accountContextDispatch, navigate]);

    // Fetch monthly credits when user logs in
    useEffect(() => {
        if (accountContext.loggedIn && accountContext.accountDetails?.accountNo && !monthlyCreditsData && !creditsDataLoading) {
            console.log('[MONTHLY CREDITS] User logged in, fetching monthly credits allowance');
            fetchMonthlyCredits();
        }
    }, [accountContext.loggedIn, accountContext.accountDetails?.accountNo]);

    // Inside your component (e.g., NavigationMenu.jsx)
    const jobsArray = Object.values(generateStatus.jobs || []);
    // Sort jobs by progress (highest first)
    const sortedJobs = jobsArray.sort((a, b) => b.progress - a.progress);
    const leadingJob = sortedJobs[0];
    const otherJobs = sortedJobs.slice(1);

    // Compute cumulative progress for all other jobs
    let cumulativeProgress = 0;
    let totalCount = otherJobs.length;

    otherJobs.forEach(job => {
        cumulativeProgress += job.progress;
    });

    const averageProgress = totalCount > 0 ? cumulativeProgress / totalCount : 0;

    // Update notification handlers
    const handleUpdateNow = () => {
        if (electronBridge.isElectron) {
            electronBridge.ipcRenderer.send('open-urlInExternal',`https://login.promptus.ai/auto-signin?v=${accountContext.accountDetails.verificationToken}&e=${accountContext.accountDetails.emailHash}&a=${accountContext.accountDetails.accountNo}&r=/account`)
        } else {
            // For web version, open download page or GitHub releases
            window.location.reload();
        }
    };

    const handleDismissUpdate = () => {
        setUpdateDismissed(true);
        // Store dismissal for current session only
        sessionStorage.setItem('updateDismissedThisSession', 'true');
    };

    const handleDismissPermanently = () => {
        setUpdateDismissed(true);
        setUpdateAvailable(false);
        // Store in localStorage to persist across sessions
        localStorage.setItem('dismissedUpdateVersion', latestVersion);
    };

    return (
        <>
        {/* Update notification banner */}
        {updateAvailable && !updateDismissed && (
            <div className="fixed top-0 left-0 right-0 z-[10000] bg-cyan backdrop-blur-sm text-dark-blue px-4 py-3 shadow-lg border-b border-yellow/30">
                <div className="flex items-center justify-between max-w-7xl mx-auto">
                    <div className="flex items-center space-x-3">
                        <div className="w-7 h-7 rounded-full bg-dark-blue/20 flex items-center justify-center">
                            <span className="text-sm font-bold">!</span>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
                            <span className="font-bold text-sm sm:text-base">
                                New Update Available! Please {electronBridge.isElectron ? 'download' : 'refresh'} to get the latest changes.
                            </span>
                            <span className="font-semibold text-xs sm:text-sm opacity-90">
                                Updated Version {latestVersion} (Current Version: {currentVersion})
                            </span>
                        </div>
                    </div>
                    <div className="flex items-center space-x-2">
                        <button
                            onClick={handleUpdateNow}
                            className="bg-dark-blue/80 hover:bg-dark-blue text-white px-3 py-1 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap"
                        >
                            {electronBridge.isElectron ? 'Download' : 'Refresh'}
                        </button>
                        <button
                            onClick={handleDismissUpdate}
                            className="bg-dark-blue/20 hover:bg-dark-blue/40 text-dark-blue px-3 py-1 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap"
                        >
                            Later
                        </button>
                        <button
                            onClick={handleDismissPermanently}
                            className="bg-transparent hover:bg-dark-blue/20 text-dark-blue/70 p-1 rounded-md transition-colors duration-200"
                            title="Don't show again for this version"
                        >
                            <CloseIcon className="w-4 h-4" />
                        </button>
                    </div>
                </div>
            </div>
        )}
        <div className={`relative h-full w-full nav-width:w-[350px] min-middle:w-1/6 ${showNavMenu ? '' : 'max-middle:hidden'}`}>
            <aside className={`navigation-menu relative nav-show:sticky ${showNavMenu ? '' : 'max-middle:hidden'} ${updateAvailable && !updateDismissed ? 'mt-16' : 'top-0'} px-4 flex flex-col gap-3 items-center w-full bg-dark-blue backdrop-blur-sm text-white h-full min-h-0 flex-shrink-0 overflow-y-auto overflow-x-hidden z-[9999]`}>
                <button className="min-middle:hidden absolute top-3 left-3 w-[46px] px-1 border border-cyan/50 rounded-lg" onClick={() => setShowNavMenu(false)}><CloseIcon className={'w-full'}/></button>
                <div className={`flex flex-col items-center mt-1 sm:mt-2 md:pb-6 lg:pb-8 ${(generateStatus.loading || refreshingApp) ? 'animate-pulse' : ''}`}>
                    <div className={`w-48 cursor-pointer`} onClick={refreshApp}>
                        {(generateStatus.loading || refreshingApp) ?
                            <>
                                {animations ?
                                    <lottie-player
                                    autoplay
                                    loop
                                    mode="normal"
                                    src={PromptSpin}
                                    ></lottie-player>
                                :
                                    <img src={Logo} alt={"Promptus Logo"} />
                                }
                            </>

                        :
                            <img src={Logo} alt={"Promptus Logo"} />
                        }
                    </div>
                    <h1 className={"text-2xl font-bold"}>Promptus</h1>
                    {refreshingApp && (
                        <div className="text-sm text-yellow font-medium animate-pulse">
                            Checking for undelivered images...
                        </div>
                    )}
                </div>
                {leadingJob && (
                    <div className="transition flex flex-col items-center w-full space-y-2">
                        {/* Leading Job */}
                        <div className="w-full text-sm flex justify-between">
                            <span className="font-medium">
                                Generated {leadingJob.totalImages} of {leadingJob.count}
                            </span>
                            <span className="font-medium">
                                {Math.ceil(leadingJob.progress)}%
                            </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2.5">
                            <div
                                className="bg-yellow h-2.5 rounded-full animate-pulse"
                                style={{ width: `${leadingJob.progress}%` }}
                            ></div>
                        </div>
                        <div className="w-full text-xs mt-1">
                            <span className="font-medium">Job UID:</span> {leadingJob.uid}
                        </div>

                        {/* Cancel Button - only show for active jobs */}
                        {leadingJob.status === 'generating' && (
                            <div className="w-full mt-2 flex justify-end">
                                <button
                                    onClick={() => handleCancelJob(leadingJob.uid)}
                                    className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-xs font-medium transition-colors duration-200 shadow-sm"
                                    title={`Cancel job ${leadingJob.uid}`}
                                >
                                    Cancel Job
                                </button>
                            </div>
                        )}
                        {leadingJob.status === 'cancelling' && (
                            <div className="w-full mt-2 flex justify-end">
                                <span className="text-red-500 text-xs font-medium">Cancelling...</span>
                            </div>
                        )}

                        {/* Cumulative Progress of other jobs */}
                        {totalCount > 0 && (
                            <div className="w-full mt-3">
                                <div className="flex justify-between text-xs mb-1">
                                    <span className="font-medium">Other Jobs ({otherJobs.length})</span>
                                    <span className="font-medium">{Math.ceil(averageProgress)}%</span>
                                </div>
                                <div className="w-full bg-gray-200 rounded-full h-2.5">
                                    <div
                                        className="bg-blue-500 h-2.5 rounded-full animate-pulse"
                                        style={{ width: `${averageProgress}%` }}
                                    ></div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {/* {Object.keys(generateStatus.jobs || {}).length > 0 ? (
                    <div className="transition flex flex-col items-center w-full space-y-4">
                        {Object.values(generateStatus.jobs).map(job => (
                            <div key={job.uid} className="w-full border border-gray-300 rounded-lg p-3 shadow-sm">
                                <div className="flex flex-row justify-between w-full text-sm">
                                    <span className="font-medium">
                                        Generated {job.count ? `${job.totalImages} of ${job.count}` : ''}
                                    </span>
                                    <span className="font-medium">
                                        {`${(Number(job.progress) >= 0) ? Math.ceil(Number(job.progress)) : 0}%`}
                                    </span>
                                </div>
                                <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 mt-2">
                                    <div
                                        className="bg-yellow h-2.5 rounded-full animate-pulse"
                                        style={{ width: `${Number(job.progress)}%` }}
                                    ></div>
                                </div>
                                <div className="flex flex-col w-full text-sm mt-2">
                                    <span className="font-medium">Job UID:</span>
                                    <span className="font-medium">{job.uid}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null} */}
                {/* {(generateStatus.loading || generateStatus.undeliveredImages) ?
                    <div className={"transition flex flex-col items-center w-full"}>
                        <div className={"flex flex-row justify-between w-full text-sm"}>
                            {generateStatus.undeliveredImages ?
                                <span className={"font-medium"}>{undeliveredStatus}</span>
                            :
                                <>
                                    <span className={"font-medium"}>Generated {generateStatus.count ? `${generateStatus.totalImages} of ${generateStatus.count}` : ''}</span>
                                    <span className={"font-medium"}>{`${(Number(generateStatus.progress) >= 0) ? Math.ceil(Number(generateStatus.progress)) : 0}%`}</span>
                                </>
                            }
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                            {generateStatus.undeliveredImages ?
                                <div className="bg-green-500 h-2.5 rounded-full animate-pulse" style={{width: `100%`}}></div>
                            :
                                <div className="bg-yellow h-2.5 rounded-full animate-pulse" style={{width: `${Number(generateStatus.progress)}%`}}></div>
                            }
                        </div>
                        {generateStatus.undeliveredImages ?
                            <>
                                <div className={"flex flex-col w-full text-sm mt-2"}>
                                    <div className="flex flex-row">
                                        <span className={"font-medium"}>Retrieved</span>
                                        <span className={"ms-1 font-medium"}>{generateStatus.totalRetrievedImages} out of {generateStatus.totalUndeliveredImages} images</span>
                                    </div>
                                    <button className={`rounded-lg bg-red-800 py-1 px-2 shadow-xl font-bold text-base w-1/2 mt-2 ml-auto`} onClick={() => generateStatusDispatch({ type: 'cancellingUndeliveredCheck' })}>Cancel</button>
                                </div>
                            </>
                        :
                            <>
                                <div className={"flex flex-col w-full text-sm mt-2"}>
                                    <span className={"font-medium"}>Job UID:</span>
                                    <span className={"font-medium"}>{generateStatus.uid}</span>
                                </div>
                            </>
                        }
                    </div>
                    :
                    null
                } */}
                {/* Pending workload UI removed - now shown in multi-job display above */}       
                {/* Navigation items section */}
                <div className={"flex flex-col w-full gap-4 items-center mt-4"} style={{ height: 'auto !important' }}>
                    {menuState.menuItems.map((item, index) => {
                        // Handle conditional rendering for items like comfy visibility
                        if (item.conditionalRender === 'comfyVisibility' && !comfyVisibility) {
                            return null;
                        }


                        // Hide MOMM menu item if user is not logged in
                        if (item.id === 'momm' && !accountContext.loggedIn) {
                            return null;
                        }

                        // Hide CosyUI menu item if Preview CosyUI is disabled
                        if (item.id === 'cosyui' && !previewCosyUI) {
                            return null;
                        }

                        if (item.id === 'cosyflow-editor' && accountContext.accountDetails.accountTypeId !== "3") {
                            return null;
                        }

                        // Get the proper icons from our mapping
                        const Icon = iconMap[item.icon];
                        const ActiveIcon = iconMap[item.activeIcon];
                        
                        // Skip rendering if icons aren't found
                        if (!Icon || !ActiveIcon) {
                            console.error(`Icon not found: ${item.icon} or ${item.activeIcon}`);
                            return null;
                        }

                        // Dynamic label handling for Profile/Login button
                        const buttonLabel = item.dynamicLabel 
                            ? `${accountContext.loggedIn ? 'Profile' : 'Login'}`
                            : item.label;

                        return (
                            <MenuButton
                                key={item.id}
                                icon={Icon}
                                activeIcon={ActiveIcon}
                                label={buttonLabel}
                                to={item.to}
                                onClick={() => {
                                    setUpdate(!update);
                                    if (item.id === 'playground') {
                                        driverContextDispatch({type: 'reset'});
                                    }
                                }}
                                onMobileNavigate={handleMobileNavigation}
                                isEditMode={true}
                                menuItems={menuState.menuItems}
                                onReorder={(items) => menuDispatch({ type: 'REORDER', payload: items })}
                                index={index}
                                isFirst={index === 0}
                                isLast={index === menuState.menuItems.length - 1}
                            />
                        );
                    })}
                    <div className={"text-xs place"}>v{process.env.REACT_APP_VERSION}</div>
                </div>
                <p className="text-lg font-bold mt-2">Server Status</p>
                <div className="grid grid-cols-2 justify-center items-center w-full max-w-md mx-auto">
                    <div className="bg-dark-blue/30 flex flex-row rounded-xl justify-start items-center p-2">
                        <Toggles status={activeCPU} />
                        <span className={`font-bold text-lg ${serverCPU ? 'text-yellow' : 'text-gray-400'} transition`}>
                        CPU Server
                        </span>
                    </div>
                    <div className="bg-dark-blue/30 flex flex-row rounded-xl justify-start items-center p-2">
                        <Toggles status={activeGPU} />
                        <span className={`font-bold text-lg ${serverGPU ? 'text-yellow' : 'text-gray-400'} transition`}>
                        GPU Server
                        </span>
                    </div>
                    <div className="bg-dark-blue/30 flex flex-row rounded-xl justify-start items-center p-2">
                        <Toggles status={activeComfyUI} />
                        <span className="font-bold text-lg text-gray-400 transition">
                        ComfyUI Server
                        </span>
                    </div>
                    <div className="bg-dark-blue/30 flex flex-row rounded-xl justify-start items-center p-2">
                        <Toggles status={activeCosy} />
                        <span className={`font-bold text-lg ${serverCosy ? 'text-yellow' : 'text-gray-400'} transition`}>
                        Cosy Server
                        </span>
                    </div>
                    <div className="bg-dark-blue/30 flex flex-row rounded-xl justify-start items-center p-2">
                        <Toggles status={activeHorde} />
                        <span className="font-bold text-lg text-gray-400 transition">
                        Horde Server
                        </span>
                    </div>
                    <div className="bg-dark-blue/30 flex flex-row rounded-xl justify-start items-center p-2">
                        <Toggles status={activeCWorker} />
                        <span className="font-bold text-lg text-gray-400 transition">
                        CWorker Server
                        </span>
                    </div>
                    </div>
            </aside>

            {/* Desktop TEMPLATES button - original absolute positioning */}
            <button
                id="templates-trigger-button-desktop"
                className="hidden min-middle:block wiggle-animation py-8 px-3 rounded-r-lg shadow-2xl transition-all duration-300 absolute right-0 top-1/2 -translate-y-1/2 translate-x-full"
                style={{
                    zIndex: 99999,
                    backgroundColor: '#FFB02E',
                    color: '#000000',
                    border: '2px solid #FF9500'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FFC04D'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#FFB02E'}
                onClick={() => eventBus.emit('toggle_content_overlay')}
            >
                <span className="writing-mode-vertical-lr text-sm font-bold whitespace-nowrap tracking-wider">TEMPLATES</span>
            </button>

        </div>

        {/* Mobile TEMPLATES button - fixed positioning for mobile screens */}
        <button
            id="templates-trigger-button-mobile"
            className={`${showNavMenu ? 'hidden' : 'block min-middle:hidden'} wiggle-animation py-8 px-3 rounded-r-lg shadow-2xl transition-all duration-300 fixed top-1/2 -translate-y-1/2 left-4`}
            style={{
                zIndex: 99999,
                backgroundColor: '#FFB02E',
                color: '#000000',
                border: '2px solid #FF9500'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FFC04D'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#FFB02E'}
            onClick={() => eventBus.emit('toggle_content_overlay')}
        >
            <span className="writing-mode-vertical-lr text-sm font-bold whitespace-nowrap tracking-wider">TEMPLATES</span>
        </button>

        {showOptimizationPopup && (
                <div style={{
                    position: 'fixed',
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: 'rgba(0,0,0,0.85)',
                    color: 'white',
                    zIndex: 9999,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '2rem'
                }}>
                    <div>
                        OPTIMIZING SAVED PLAYGROUND IMAGES, PLEASE HOLD...
                    </div>
                    <div style={{ fontSize: '1.2rem', marginTop: '1rem' }}>
                        {optimizationProgress.current} of {optimizationProgress.total} images optimized
                    </div>
                    <div style={{ marginTop: '2rem' }}>
                        <div style={{
                            width: '375px',
                            height: '20px',
                            background: '#333',
                            borderRadius: '5px',
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                width: `${(optimizationProgress.current / Math.max(1, optimizationProgress.total)) * 100}%`,
                                height: '100%',
                                background: '#FFB02E',
                                transition: 'width 0.3s'
                            }} />
                        </div>
                    </div>
                </div>
        )}
        </>
    );
};

export default memo(NavigationMenu);